export const common = {
  // Navigation
  'nav.slogan': 'Ein KI-Urteil zu deiner Geschäftsidee — bevor du baust',
  'nav.features': 'Funktionen',
  'nav.howItWorks': 'So funktioniert es',
  'nav.pricing': 'Preise',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Über uns',
  'nav.getStarted': 'Loslegen',

  // About Us Section
  'aboutUs.badge': "Über uns",
  'aboutUs.title': "Wir streiten mit deiner Idee, damit du später nicht mit der Realität streitest.",
  'aboutUs.line1': "Die meisten Ideen scheitern nicht am fehlenden Talent des Gründers.",
  'aboutUs.line2': "Sie scheitern, weil niemand früh die Wahrheit sagt — wenn ein Kurswechsel noch günstig ist.",
  'aboutUs.paragraph1':
    "IdeaVerdict schließt diese Lücke. Wir testen deine Idee gegen die Marktsignale, die wirklich über den Erfolg entscheiden: Nachfrage, Wettbewerb, Kapital, Zeit, Skalierbarkeit. Wir handeln nicht mit Motivation. Wir handeln mit Marktevidenz.",
  'aboutUs.belief1a': "Wir handeln nicht mit Motivation.",
  'aboutUs.belief1b': "Wir handeln mit Marktevidenz.",
  'aboutUs.belief2a': "Wir verkaufen keine Hoffnung.",
  'aboutUs.belief2b': "Wir liefern ein klares Bild davon, womit deine Idee es zu tun hat.",
  'aboutUs.mission1': "Unsere Aufgabe ist nicht, deine Idee gut aussehen zu lassen.",
  'aboutUs.mission2': "Unsere Aufgabe ist, dir zu sagen, ob sie es ist.",
  'aboutUs.analysis':
    "Wir bewerten deine Idee anhand von sieben Faktoren, die über das Überleben entscheiden: Nachfrage, Wettbewerb, Startkapital, Time-to-Revenue, Gewinnpotenzial, Skalierbarkeit und Risiko. Keine Emotion. Kein Optimismus. Nur Analyse.",
  'aboutUs.failure1': "Die meisten Unternehmen scheitern.",
  'aboutUs.failure2': "Nicht, weil die Menschen dahinter unfähig waren —",
  'aboutUs.failure3': "sondern weil niemand früh genug stark genug widersprochen hat.",
  'aboutUs.clarity': "Wir existieren, um zu widersprechen.",
  'aboutUs.value1': "Direkt.",
  'aboutUs.value2': "Ehrlich.",
  'aboutUs.value3': "Schnell.",
  'aboutUs.confirm': "Wenn deine Idee Substanz hat, stehen wir dahinter.",
  'aboutUs.deny': "Wenn nicht, sagen wir es dir ins Gesicht.",
  'aboutUs.noApplause': "Kein Applaus.",
  'aboutUs.noSugarcoating': "Kein Cheerleading.",
  'aboutUs.noTheater': "Kein Theater.",
  'aboutUs.noHype': "Nur das Urteil.",
  // Hero Section
  'hero.badge': 'KI-Ideen-Urteil · in unter 60 Sekunden',
  'hero.title1': 'Schluss mit Raten.',
  'hero.title2': 'Starte mit einem Urteil.',
  'hero.subtitle': 'IdeaVerdict prüft deine Geschäftsidee in sieben harten Checks',
  'hero.subtitleLine2': 'und gibt dir eine klare Antwort — bauen, anpassen oder verwerfen.',
  'hero.cta': 'Mein Urteil holen',
  'hero.ctaSecondary': 'So funktioniert es',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Credits pro Analyse',
  'hero.stat2Value': '7',
  'hero.stat2Label': 'Urteilsdimensionen',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Ehrlich & privat',

  // Features Section
  'features.title1': 'Gemacht für',
  'features.title2': 'Gründer,',
  'features.title3': 'die Signal statt Lärm wollen.',
  'features.bullet1.title': 'Eine zweite Meinung, der du trauen kannst',
  'features.bullet1.description':
    'Jede Analyse wird mit Stark, Gemischt oder Schwach bewertet — mit der Begründung dahinter. Kein Applaus, kein Schönreden. Nur das, was der Markt dir wahrscheinlich zurückgeben wird.',
  'features.bullet2.title': 'Bewertet nach dem, was dem Markt wichtig ist',
  'features.bullet2.description':
    'Echte Nachfrage. Wettbewerb. Benötigtes Kapital. Time-to-Revenue. Skalierbarkeit. Die Dinge, auf die VCs zuerst schauen — angewendet auf deine Idee, bevor du etwas gebaut hast.',
  'features.bullet3.title': 'Von der Idee zum entwicklerfertigen Plan',
  'features.bullet3.description':
    'Der Builder-Modus wandelt ein grünes-Licht-Urteil in ein strukturiertes Briefing um: User Flows, Kernfunktionen, technische Notizen. Du überspringst das Whiteboard und gibst es direkt an einen Entwickler weiter.',

  // How It Works
  'howItWorks.title': 'So funktioniert es',
  'howItWorks.subtitle': 'Vier Schritte. Insgesamt etwa zehn Minuten.',
  'howItWorks.step1Title': 'Wähle deine Tiefe',
  'howItWorks.step1Desc': 'Starter für schnelle Checks. Pro für vollständige Analyse. Builder für versandfertige Briefings. Wähle das Passende für deine Phase.',
  'howItWorks.step2Title': 'Erzähle der KI deine Idee',
  'howItWorks.step2Desc': 'Ein Absatz. Je klarer du sie formulierst, desto schärfer das Urteil. Jede Analyse kostet 30 Credits.',
  'howItWorks.step3Title': 'Lies das Urteil',
  'howItWorks.step3Desc': 'Stark, Gemischt oder Schwach — über sieben Dimensionen. Plus eine Punktzahl von 100, über die du diskutieren kannst.',
  'howItWorks.step4Title': 'Entscheide, was als nächstes kommt',
  'howItWorks.step4Desc': 'Bauen. Schärfen. Pivotieren. Verwerfen. Du weißt, was zu tun ist — und warum.',

  // Pricing
  'pricing.title': 'Preise',
  'pricing.subtitle': 'Wählen Sie den Plan, der zu Ihrer Prüfungstiefe passt.',
  'pricing.monthly': 'Monatlich',
  'pricing.yearly': 'Jährlich',
  'pricing.yearlyDiscount': 'Jahresabo:',
  'pricing.yearlyDiscountValue': '-20% Rabatt',
  'pricing.perMonth': 'pro Monat',
  'pricing.selectPlan': 'Plan auswählen',
  'pricing.mostPopular': 'Am beliebtesten',
  'pricing.footer':
    'Alle Preise in CHF. Credits werden nur für erfolgreiche KI-Antworten abgezogen.',

  
  // Pricing Features
  'pricing.feature1': 'Freier Chat (kein Formular)',
  'pricing.feature2': 'Marktlogik & ehrliche Bewertung',
  'pricing.feature3': 'Persistenter Chat-Verlauf',
  'pricing.feature4': 'Mehrere parallele Chat-Sessions',
  'pricing.feature5': 'Vollständig mehrsprachig',
  'pricing.feature6': 'Credit-basierte Nutzung',
  'pricing.feature7': 'Monatlicher Reset',
  'pricing.feature8': 'Marktanalyse',
  'pricing.feature9': 'Zusammenfassung',
  'pricing.feature10': 'Stärken',
  'pricing.feature11': 'Schwächen',
  'pricing.feature12': 'Chancen',
  'pricing.feature13': 'Risiken',
  'pricing.feature14': 'Empfehlungen',
  'pricing.feature15': 'PDF Herunterladen',
  'pricing.feature16': 'Keine Entwickler-Briefings',
  'pricing.feature17': 'Builder-Modus: Entwickler-Briefings',
  'pricing.feature18': 'Strukturierte Zusammenfassung',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39,90',
  'pricing.starter.description': 'Zugang zum KI-Nischen-Chatbot',
  'pricing.starter.credits': '2.500 Credits pro Monat',
  'pricing.starter.feature1': 'Nischenidee generieren',
  'pricing.starter.feature2': 'Nische verfeinern',
  'pricing.starter.feature3': 'Marktrealitätsprüfung',
  'pricing.starter.feature4': 'Wettbewerbsbewertung',
  'pricing.starter.feature5': 'Zeitbewertung',
  'pricing.starter.feature6': 'Ehrliches Urteil',
  'pricing.starter.feature7': 'Private Sitzungen',
  'pricing.starter.feature8': 'Verlauf & Export',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59,90',
  'pricing.pro.description': 'Zugang zum KI-Nischen-Chatbot',
  'pricing.pro.credits': '5.000 Credits pro Monat',
  'pricing.pro.feature1': 'Alle Starter-Funktionen',
  'pricing.pro.feature2': 'Mehr Credits für intensive Prüfungen',
  'pricing.pro.feature3': 'Verbesserungsvorschläge',
  'pricing.pro.feature4': 'Alternative Nischen',
  'pricing.pro.feature5': 'Detaillierte Marktanalyse',
  'pricing.pro.feature6': 'Prioritärer Support',
  'pricing.pro.feature7': 'Erweiterte Filter',
  'pricing.pro.feature8': 'Sitzungsfavoriten',

  // Builder Plan
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Alle Funktionen + Builder-Modus",
  'pricing.builder.credits': "10.000 Credits pro Monat",
  'pricing.builder.feature1': 'Alle Pro-Funktionen',
  'pricing.builder.feature2': 'Unbegrenzte KI-Anfragen',
  'pricing.builder.feature3': 'Builder-Modus: Entwickler-Briefings',
  'pricing.builder.feature4': 'Strukturierte Projektübersicht',
  'pricing.builder.feature5': 'User Flows & Kernfunktionen',
  'pricing.builder.feature6': 'Technische Hinweise',
  'pricing.builder.feature7': 'Nicht-Ziele definieren',
  'pricing.builder.feature8': 'Fair-Use-Ratenlimit',
  'pricing.builder.limitNote': 'Fair-Use-Limit',
  'pricing.monthlyReset': 'Monatliche Zurücksetzung',

  // Modal
  'pricing.modal.selected': 'ausgewählt',
  'pricing.modal.comingSoon': 'Registrierung und Zahlungsabwicklung werden in Kürze verfügbar sein.',
  'pricing.modal.patience': 'Wir arbeiten daran, Ihnen ein sicheres und nahtloses Erlebnis zu bieten. Bitte haben Sie Geduld.',
  'pricing.modal.understood': 'Verstanden',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Direkte Antworten, kein Marketing.',
  'faq.q1': "Was macht IdeaVerdict eigentlich?",
  'faq.a1': "Es bewertet deine Geschäftsidee anhand der sieben Faktoren, die darüber entscheiden, ob sie einen Markt übersteht: Nachfrage, Wettbewerb, Startkapital, Time-to-Revenue, Gewinnpotenzial, Skalierbarkeit und Risiko.\nDu bekommst ein Urteil, eine Zahl und die Begründung für beides.",
  'faq.q2': "Generiert ihr auch Ideen oder kritisiert ihr nur meine?",
  'faq.a2': "Beides.\nErzähl uns von deinen Fähigkeiten, deinem Kapital und deiner Zeit — wir bringen Nischen mit echten Marktlücken hervor.\nOder gib deine eigene Idee ein und wir zerlegen sie.",
  'faq.q3': "Was unterscheidet euch von ChatGPT?",
  'faq.a3': "ChatGPT versucht, hilfreich zu sein.\nWir versuchen, genau zu sein.\nWir sind darauf trainiert, dagegen zu argumentieren, wenn die Rechnung nicht aufgeht — anstatt Gründe zu finden, warum deine Idee großartig ist.",
  'faq.q4': "Garantiert das, dass meine Idee erfolgreich wird?",
  'faq.a4': "Kein Tool garantiert das.\nWir helfen dir, offensichtlich schlechte Wetten zu vermeiden und die mit einer Chance zu schärfen.\nDas Risiko verschwindet nicht — aber du gehst mit offenen Augen hinein.",
  'faq.q5': "Für wen ist das?",
  'faq.a5': "Gründer vor dem Launch.\nOperators vor einer Nebenwette.\nBuilder vor dem Wochenendprojekt.\nInvestoren vor der Unterschrift.\n\nJeder, der Klarheit vor dem Commitment will.",
  'faq.q6': "Was, wenn ich nur jemanden möchte, der mir sagt, dass meine Idee großartig ist?",
  'faq.a6': "Dann sind wir das falsche Tool.\nWir geben einen ehrlichen Read, keine Beruhigung.",
  'faq.q7': "Wie ehrlich ist die Analyse wirklich?",
  'faq.a7': "So ehrlich, wie es die Daten erlauben.\nWir mildern ein schwaches Urteil nicht, um Gefühle zu schonen.\nWenn deine Idee ein Problem hat, sagen wir es — und wir sagen, wo es liegt.",
  'faq.q8': "Ersetzt das echte Marktforschung?",
  'faq.a8': "Nein.\nEs ist ein schneller strategischer Check, bevor du Zeit und Geld einsetzt — keine 50-seitige Studie.\nNutze uns, um zu entscheiden, ob die tiefere Recherche es wert ist.",
  'faq.q9': "Was fügt der Builder-Modus hinzu?",
  'faq.a9': "Sobald ein Urteil positiv ist, verwandelt der Builder-Modus es in ein Entwickler-Briefing: User Flows, Kernfunktionen, Monetarisierungsmodell, technische Überlegungen.\nDas, was du deinem ersten Entwickler in die Hand drücken würdest.",
  'faq.q10': "Warum so direkt?",
  'faq.a10': "Weil das Falsche zu bauen Monate kostet.\nEin ehrliches Urteil kostet Minuten.\n\nWir wählen die Minuten.",
  // Footer
  'footer.description':
    "IdeaVerdict ist nicht hier, damit du dich gut fühlst über deine Idee. Es ist hier, damit du entscheidest, ob du auf sie setzen sollst.",
  'footer.product': 'Produkt',
  'footer.aiAssistant': 'KI-Assistent',
  'footer.howItWorks': 'So funktioniert es',
  'footer.pricing': 'Preise',
  'footer.faq': 'FAQ',
  'footer.legal': 'Rechtliches',
  'footer.privacy': 'Datenschutz',
  'footer.terms': 'AGB',
  'footer.imprint': 'Impressum',
  'footer.support': 'Support',
  'footer.contact': 'Kontakt',
  'footer.documentation': 'Dokumentation',
  'footer.copyright': '© 2026 IdeaVerdict. Alle Rechte vorbehalten.',

  // AI Assistant
  'aiAssistant.title': 'KI-Nischen-Assistent',
  'aiAssistant.subtitle': 'Fragen Sie nach Nischen',
  'aiAssistant.welcomeMessage':
    'Hallo! Beschreiben Sie Ihre Idee oder fragen Sie mich nach einer Nische. Ich gebe Ihnen eine klare und ehrliche Bewertung.',
  'aiAssistant.demoResponse':
    'Dies ist eine Demo. Für echte KI-Bewertungen registrieren Sie sich bitte und wählen Sie einen Plan.',
  'aiAssistant.placeholder': 'Beschreiben Sie Ihre Idee...',

  // Header & Sidebar
  'dashboard.header.title': 'Dashboard',
  'dashboard.header.aiAssistant': 'Ihr KI-Assistent',
  'header.logout': 'Abmelden',
  'dashboard.sidebar.overview': 'Übersicht',
  'dashboard.sidebar.aiChat': 'KI-Assistent',
  'dashboard.sidebar.newAnalysis': 'KI-Assistent',
  'dashboard.sidebar.history': 'Verlauf',
  'dashboard.sidebar.credits': 'Credits',
  'dashboard.sidebar.settings': 'Einstellungen',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Willkommen zurück, {{name}}',
  'dashboard.overview.subtitle': 'Hier ist eine kurze Übersicht Ihrer Aktivitäten',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Verbleibende Credits',
  'dashboard.stats.totalAnalyses': 'Analysen insgesamt',
  'dashboard.stats.goodRatings': 'Positive Bewertungen',
  'dashboard.stats.nextReset': 'Nächste Zurücksetzung in',
  'dashboard.stats.days': 'Tagen',

  // Quick Actions
  'dashboard.quickActions.title': 'Schnellaktionen',
  'dashboard.quickActions.checkNewIdea': 'Idee prüfen',
  'dashboard.quickActions.checkNewIdeaDesc': 'Eine bestehende Geschäftsidee analysieren',
  'dashboard.quickActions.generateIdea': 'Idee generieren',
  'dashboard.quickActions.generateIdeaDesc': 'Eine neue profitable Nische finden',
  'dashboard.quickActions.builderBriefing': 'Builder-Briefing',
  'dashboard.quickActions.builderBriefingDesc': 'Eine Idee in ein entwicklerfertiges Briefing verwandeln',
  'dashboard.quickActions.premiumOnly': 'Nur Builder',

  // Chat Header
  'chat.title': 'KI-Nischen-Assistent',
  'chat.subtitle': 'Stellen Sie Fragen zu Nischen. Ich bewerte kritisch und ehrlich.',
  'chat.creditsLabel': 'Credits',

  // Chat Welcome
  'chat.welcomeTitle': 'Willkommen beim KI-Nischen-Assistenten',
  'chat.welcomeDesc': 'Beschreiben Sie Ihre Idee oder fragen Sie nach einer Nische. Ich bewerte sie ehrlich: Gut, Durchschnittlich oder Schlecht.',
  'chat.aiWelcome': 'Hallo! Beschreiben Sie Ihre Idee oder fragen Sie mich nach einer Nische. Ich gebe Ihnen eine klare und ehrliche Bewertung.',

  // Chat Suggestions
  'chat.suggestion1': 'Ich möchte ein SaaS-Tool für Freelancer zur Rechnungsverwaltung bauen. Ist das eine gute Nische?',
  'chat.suggestion2': 'Finde mir ein Online-Business mit wenig Konkurrenz, das ich mit 500 CHF und ohne Programmierkenntnisse starten kann.',
  'chat.suggestion3': 'Bewerte das: Eine KI-gestützte Essensplanungs-App für vielbeschäftigte Eltern mit Ernährungseinschränkungen.',
  'chat.suggestion4': 'Ich möchte digitale Vorlagen auf Etsy für Kleinunternehmer verkaufen. Analysiere diese Nische ehrlich.',

  // Chat Actions
  'chat.newConversation': 'Neue Unterhaltung',
  'chat.today': 'Heute',
  'chat.yesterday': 'Gestern',
  'chat.thisWeek': 'Diese Woche',
  'chat.thisMonth': 'Diesen Monat',
  'chat.older': 'Älter',
  'chat.messages': 'Nachrichten',
  'chat.renameConversation': 'Umbenennen',
  'chat.deleteConversation': 'Löschen',
  'chat.cancel': 'Abbrechen',
  'chat.rename': 'Umbenennen',
  'chat.delete': 'Löschen',
  'chat.favorite': 'Zu Favoriten hinzufügen',
  'chat.unfavorite': 'Aus Favoriten entfernen',
  'chat.searchSessions': 'Unterhaltungen durchsuchen...',
  'chat.noResults': 'Keine Ergebnisse gefunden',
  'chat.noSessions': 'Noch keine Unterhaltungen',
  'chat.enterNewName': 'Neuen Namen eingeben...',
  'chat.deleteConfirmMessage': 'Sind Sie sicher, dass Sie diese Unterhaltung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Geben Sie Ihre Frage ein… (kostet 30 Credits)',
  'chat.send': 'Senden',
  'chat.voice': 'Sprechen',
  'chat.listeningPlaceholder': 'Ich höre zu... Sprechen Sie jetzt.',
  'chat.stopListening': 'Hören aufhören',
  'chat.recording': 'Aufnahme...',
  'chat.speechNotSupported': 'Ihr Browser unterstützt keine Spracherkennung.',
  'chat.microphonePermissionDenied': 'Mikrofonzugriff verweigert. Bitte erlauben Sie den Zugriff in den Browsereinstellungen.',
  'chat.errorNotEnoughCredits': 'Nicht genügend Credits. Bitte upgraden Sie Ihren Plan oder warten Sie auf die nächste Zurücksetzung.',
  'chat.errorAiFailed': 'KI-Antwort fehlgeschlagen. Es wurden keine Credits abgezogen.',
  'chat.errorRateLimit': 'Zu viele Anfragen. Bitte warten Sie einen Moment.',
  'chat.creditsPerQuestion': 'Credits/Frage',
  'chat.notEnoughCreditsTitle': 'Nicht genug Credits',
  'chat.notEnoughCreditsDesc': 'Du benötigst mindestens {{cost}} Credits pro Frage.',
  'chat.creditsRunningLow': 'Credits werden knapp',
  'chat.questionsRemaining': 'Noch {{count}} Fragen möglich.',
  'chat.noCreditsModalTitle': 'Nicht genug Credits',
  'chat.noCreditsModalDesc': 'Du benötigst mindestens <1>{{cost}} Credits</1> pro Frage. Dein aktuelles Guthaben: <2>{{balance}} Credits</2>',
  'chat.currentPlan': 'Aktueller Plan',
  'chat.close': 'Schliessen',
  'chat.upgrade': 'Upgrade',

  // Ratings
  'rating.good': 'Gut',
  'rating.medium': 'Durchschnittlich',
  'rating.bad': 'Schlecht',

  // Auth Page
  'auth.branding.headline1': 'Nicht jede Idee ist gut.',
  'auth.branding.headline2': 'Wir sagen es Ihnen ehrlich.',
  'auth.branding.subtitle': 'Eine Entscheidungs-KI für Geschäftsnischen. Klar. Kritisch. Keine Beschönigung.',
  'auth.benefits.privacy.title': '100% Privat',
  'auth.benefits.privacy.desc': 'Ihre Ideen bleiben völlig privat und sicher.',
  'auth.benefits.honest.title': 'Ehrliche KI',
  'auth.benefits.honest.desc': 'Keine Beschönigung – nur klares, kritisches Feedback.',
  'auth.benefits.fast.title': 'Schnelle Ergebnisse',
  'auth.benefits.fast.desc': 'Erhalten Sie in Minuten Klarheit über Ihre Nische.',
  'auth.trust.users': 'Aktive Benutzer',
  'auth.trust.ideas': 'Analysierte Ideen',
  'auth.trust.rating': 'Benutzerbewertung',
  'auth.login.title': 'Anmelden',
  'auth.login.headline': 'Willkommen zurück',
  'auth.login.subtitle': 'Melden Sie sich an, um Ihre Reise fortzusetzen.',
  'auth.login.forgotPassword': 'Passwort vergessen?',
  'auth.login.submit': 'Anmelden',
  'auth.login.noAccount': 'Noch kein Konto?',
  'auth.login.signUp': 'Registrieren',
  'auth.register.title': 'Registrieren',
  'auth.register.headline': 'Konto erstellen',
  'auth.register.subtitle': 'Beginnen Sie noch heute mit der Analyse Ihrer Geschäftsideen.',
  'auth.register.submit': 'Konto erstellen',
  'auth.register.hasAccount': 'Bereits ein Konto?',
  'auth.register.signIn': 'Anmelden',
  'auth.fields.name': 'Vollständiger Name',
  'auth.fields.email': 'E-Mail-Adresse',
  'auth.fields.password': 'Passwort',
  'auth.fields.confirmPassword': 'Passwort bestätigen',
  'auth.fields.selectPlan': 'Wählen Sie Ihren Plan',
  'auth.fields.testCode': 'Anmelden und kostenlos testen',
  'auth.placeholders.name': 'Geben Sie Ihren Namen ein',
  'auth.placeholders.email': 'Geben Sie Ihre E-Mail ein',
  'auth.placeholders.password': 'Geben Sie Ihr Passwort ein',
  'auth.placeholders.confirmPassword': 'Bestätigen Sie Ihr Passwort',
  'auth.placeholders.testCode': 'Testcode eingeben',
  'auth.terms.accept': 'Ich akzeptiere die',
  'auth.terms.terms': 'Allgemeinen Geschäftsbedingungen',
  'auth.privacy.accept': 'Ich akzeptiere die',
  'auth.privacy.policy': 'Datenschutzerklärung',
  'auth.errors.nameRequired': 'Name ist erforderlich',
  'auth.errors.emailRequired': 'E-Mail ist erforderlich',
  'auth.errors.emailInvalid': 'Bitte geben Sie eine gültige E-Mail ein',
  'auth.errors.passwordRequired': 'Passwort ist erforderlich',
  'auth.errors.passwordLength': 'Passwort muss mindestens 8 Zeichen lang sein',
  'auth.errors.passwordMismatch': 'Passwörter stimmen nicht überein',
  'auth.errors.invalidCode': 'Ungültiger oder abgelaufener Code',
  'auth.errors.registrationCodeOnly': 'Dieser Code ist nur für die Registrierung',
  'auth.errors.verificationFailed': 'Fehler bei der Code-Überprüfung. Bitte versuchen Sie es erneut.',
  'auth.loading': 'Bitte warten...',
  'auth.or': 'oder fortfahren mit',
  'auth.social.google': 'Mit Google fortfahren',
  'auth.social.apple': 'Mit Apple fortfahren',
  'auth.actions.verify': 'Verifizieren',
  'auth.testCode.activated': 'Testcode aktiviert!',
  'auth.testCode.days': 'Tage',
  'auth.testCode.months': 'Monate',
  'auth.testCode.freeAccess': 'kostenloser Zugang',
  'auth.testCode.credits': 'Credits',

  // Email Verification
  'auth.verification.title': 'E-Mail verifizieren',
  'auth.verification.headline': 'Überprüfen Sie Ihren Posteingang',
  'auth.verification.subtitle': 'Wir haben einen Bestätigungscode gesendet an:',
  'auth.verification.codeLabel': 'Bestätigungscode',
  'auth.verification.codePlaceholder': '6-stelligen Code eingeben',
  'auth.verification.submit': 'E-Mail verifizieren',
  'auth.verification.resend': 'Code erneut senden',
  'auth.verification.resendIn': 'Erneut senden in',
  'auth.verification.seconds': 'Sekunden',
  'auth.verification.success': 'E-Mail erfolgreich verifiziert!',
  'auth.verification.error': 'Ungültiger Code. Bitte versuchen Sie es erneut.',
  'auth.verification.expired': 'Code abgelaufen. Bitte fordern Sie einen neuen an.',
  'auth.verification.sent': 'Neuer Code gesendet!',
  'auth.verification.checkSpam': 'Nicht erhalten? Überprüfen Sie Ihren Spam-Ordner.',

  // Forgot Password
  'auth.forgot.title': 'Passwort vergessen',
  'auth.forgot.headline': 'Passwort zurücksetzen',
  'auth.forgot.subtitle': 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen.',
  'auth.forgot.submit': 'Link zum Zurücksetzen senden',
  'auth.forgot.backToLogin': 'Zurück zur Anmeldung',
  'auth.forgot.success': 'E-Mail gesendet!',
  'auth.forgot.successMessage': 'Wir haben Ihnen eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts gesendet.',
  'auth.forgot.checkInbox': 'Überprüfen Sie Ihren Posteingang',

  // Reset Password
  'auth.reset.title': 'Neues Passwort',
  'auth.reset.headline': 'Neues Passwort festlegen',
  'auth.reset.subtitle': 'Geben Sie Ihr neues Passwort ein.',
  'auth.reset.newPassword': 'Neues Passwort',
  'auth.reset.confirmNewPassword': 'Neues Passwort bestätigen',
  'auth.reset.submit': 'Passwort ändern',
  'auth.reset.success': 'Passwort erfolgreich geändert!',
  'auth.reset.successMessage': 'Sie können sich jetzt mit Ihrem neuen Passwort anmelden.',
  'auth.reset.loginNow': 'Jetzt anmelden',

  // Legal Pages
  'legal.backToAuth': 'Zurück zur Anmeldung',
  'legal.allRightsReserved': 'Alle Rechte vorbehalten.',

  // Terms Page
  'legal.terms.title': 'Allgemeine Geschäftsbedingungen',
  'legal.terms.lastUpdated': 'Zuletzt aktualisiert',
  'legal.terms.section1.title': '1. Geltungsbereich',
  'legal.terms.section1.content': 'Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen NicheFinder (nachfolgend "Anbieter") und dem Nutzer (nachfolgend "Kunde") bezüglich der Nutzung der KI-gestützten Nischenanalyseplattform.',
  'legal.terms.section2.title': '2. Leistungsbeschreibung',
  'legal.terms.section2.content': 'Der Anbieter bietet eine KI-basierte Plattform, die Geschäftsideen und -nischen analysiert und bewertet. Die Dienstleistungen umfassen:',
  'legal.terms.section2.item1': 'KI-gestützte Analyse von Geschäftsideen',
  'legal.terms.section2.item2': 'Bewertung von Marktpotenzial und Wettbewerb',
  'legal.terms.section2.item3': 'Generierung von Nischenvorschlägen',
  'legal.terms.section2.item4': 'Erstellung von Entwickler-Briefings (Builder-Paket)',
  'legal.terms.section3.title': '3. Vertragsabschluss und Registrierung',
  'legal.terms.section3.content': 'Der Vertrag kommt durch Registrierung auf der Plattform und Auswahl eines Pakets zustande. Der Kunde bestätigt:',
  'legal.terms.section3.item1': 'Volljährigkeit und volle Geschäftsfähigkeit',
  'legal.terms.section3.item2': 'Wahrheitsgemäße Angaben bei der Registrierung',
  'legal.terms.section3.item3': 'Sichere Aufbewahrung der Zugangsdaten',
  'legal.terms.section4.title': '4. Credits und Abrechnung',
  'legal.terms.section4.content': 'Die Nutzung von KI-Funktionen basiert auf einem Creditsystem. Jede KI-Anfrage kostet 30 Credits. Credits werden nur bei erfolgreicher Antwort abgezogen. Nicht genutzte Credits verfallen am Ende des Abrechnungszeitraums und werden nicht erstattet.',
  'legal.terms.section5.title': '5. Haftungsausschluss',
  'legal.terms.section5.content': 'KI-Bewertungen dienen lediglich als Entscheidungshilfe und garantieren keinen Geschäftserfolg. Der Anbieter haftet nicht für Entscheidungen, die auf Basis von KI-Analysen getroffen werden. Die Haftung für Vorsatz und grobe Fahrlässigkeit bleibt unberührt.',
  'legal.terms.section6.title': '6. Datenschutz und Vertraulichkeit',
  'legal.terms.section6.content': 'Alle eingereichten Geschäftsideen werden vertraulich behandelt und nicht an Dritte weitergegeben. Die Verarbeitung personenbezogener Daten erfolgt gemäß unserer Datenschutzerklärung und den geltenden Datenschutzgesetzen.',
  'legal.terms.section7.title': '7. Kündigung',
  'legal.terms.section7.content': 'Der Kunde kann sein Abonnement jederzeit zum Ende des aktuellen Abrechnungszeitraums kündigen. Bei Verstößen gegen diese AGB behält sich der Anbieter vor, den Zugang zur Plattform zu sperren.',
  'legal.terms.section8.title': '8. Schlussbestimmungen',
  'legal.terms.section8.content': 'Es gilt Schweizer Recht. Gerichtsstand ist Zürich, Schweiz. Sollten einzelne Bestimmungen dieser AGB ungültig sein, bleibt die Gültigkeit der übrigen Bestimmungen unberührt.',
  'legal.terms.contact.title': 'Fragen zu den AGB?',
  'legal.terms.contact.content': 'Wenn Sie Fragen zu diesen Allgemeinen Geschäftsbedingungen haben, kontaktieren Sie uns bitte unter:',

  // Privacy Page
  'legal.privacy.title': 'Datenschutzerklärung',
  'legal.privacy.section1.title': '1. Verantwortlicher',
  'legal.privacy.section1.content': 'Der Verantwortliche für diese Website ist NicheFinder, Zürich, Schweiz. Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst und behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften.',
  'legal.privacy.section2.title': '2. Erhobene Daten',
  'legal.privacy.section2.content': 'Wir erheben und verarbeiten folgende personenbezogene Daten:',
  'legal.privacy.section2.item1': 'Registrierungsdaten: Name, E-Mail-Adresse, Passwort (verschlüsselt)',
  'legal.privacy.section2.item2': 'Nutzungsdaten: IP-Adresse, Browsertyp, Zugriffszeiten',
  'legal.privacy.section2.item3': 'Geschäftsideen und Nischenanfragen (anonym gespeichert)',
  'legal.privacy.section2.item4': 'Zahlungsinformationen (über sichere Drittanbieter)',
  'legal.privacy.section3.title': '3. Zweck der Datenverarbeitung',
  'legal.privacy.section3.content': 'Ihre Daten werden für folgende Zwecke verwendet:',
  'legal.privacy.section3.item1': 'Bereitstellung und Verbesserung unserer KI-Dienste',
  'legal.privacy.section3.item2': 'Kontoverwaltung und Authentifizierung',
  'legal.privacy.section3.item3': 'Abrechnung und Zahlungsabwicklung',
  'legal.privacy.section4.title': '4. Datensicherheit',
  'legal.privacy.section4.content': 'Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen Manipulation, Verlust, Zerstörung oder unbefugten Zugriff zu schützen. Alle Datenübertragungen werden per SSL/TLS verschlüsselt.',
  'legal.privacy.section5.title': '5. Vertraulichkeit Ihrer Geschäftsideen',
  'legal.privacy.section5.content': 'Ihre eingereichten Geschäftsideen und Nischenanfragen werden streng vertraulich behandelt. Sie werden nicht an Dritte weitergegeben, nicht für Trainingszwecke verwendet und können auf Anfrage vollständig gelöscht werden. Ihre Ideen gehören Ihnen.',
  'legal.privacy.section6.title': '6. Ihre Rechte',
  'legal.privacy.section6.content': 'Sie haben die folgenden Rechte bezüglich Ihrer personenbezogenen Daten:',
  'legal.privacy.section6.item1': 'Recht auf Auskunft über gespeicherte Daten',
  'legal.privacy.section6.item2': 'Recht auf Berichtigung unrichtiger Daten',
  'legal.privacy.section6.item3': 'Recht auf Löschung Ihrer Daten',
  'legal.privacy.section6.item4': 'Recht auf Datenübertragbarkeit',
  'legal.privacy.section7.title': '7. Cookies',
  'legal.privacy.section7.content': 'Unsere Website verwendet nur technisch notwendige Cookies für Authentifizierung und Sitzungsverwaltung. Wir verwenden keine Tracking-Cookies oder Analyse-Tools Dritter ohne Ihre ausdrückliche Zustimmung.',
  'legal.privacy.section8.title': '8. Änderungen dieser Datenschutzerklärung',
  'legal.privacy.section8.content': 'Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um geänderten gesetzlichen Anforderungen oder bei Änderungen des Dienstes zu entsprechen. Die aktuelle Version ist jederzeit auf dieser Seite zu finden.',
  'legal.privacy.contact.title': 'Fragen zum Datenschutz?',
  'legal.privacy.contact.content': 'Wenn Sie Fragen zur Verarbeitung Ihrer personenbezogenen Daten haben, kontaktieren Sie uns bitte unter:',

  'auth.passwordStrength.label': 'Passwortstärke',
  'auth.passwordStrength.weak': 'Schwach',
  'auth.passwordStrength.medium': 'Mittel',
  'auth.passwordStrength.strong': 'Stark',
  'auth.passwordStrength.veryStrong': 'Sehr stark',
  'auth.passwordStrength.minLength': 'Min. 8 Zeichen',
  'auth.passwordStrength.uppercase': 'Großbuchstabe',
  'auth.passwordStrength.number': 'Zahl',
  'auth.passwordStrength.special': 'Sonderzeichen',

  trial: {
    subtitle: 'Kostenlose Testversion',
    upgrade: 'Jetzt upgraden',
    creditsRemaining: 'Credits übrig',
    inputHint: 'Testversion - Kein Gesprächsverlauf verfügbar',
    banner: {
      title: '7-Tage-Testversion aktiv',
      remaining: '{{days}} Tage verbleibend',
      credits: 'Credits verfügbar',
      upgradeNow: 'Jetzt upgraden',
    },
    welcome: {
      title: 'Willkommen zur kostenlosen Testversion!',
      desc: 'Testen Sie unseren KI-Assistenten 7 Tage lang kostenlos mit 100 Credits. Stellen Sie Fragen und entdecken Sie die Möglichkeiten!',
    },
    info: {
      title: 'Einschränkungen der Testversion',
      credits: '100 Credits für 7 Tage',
      noHistory: 'Kein Gesprächsverlauf',
      noSettings: 'Eingeschränkte Funktionen',
      upgrade: 'Upgrade für volle Funktionen',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': 'Einstellungen',
  'settings.subtitle': 'Verwalten Sie Ihr Konto und Ihre Präferenzen',
  'settings.backToOverview': 'Zurück zur Übersicht',
  'settings.subscriptionLink': 'Abonnement & Abrechnung',
  'settings.saved': 'Änderungen erfolgreich gespeichert',
  'settings.changesSaved': 'Änderungen gespeichert',
  'settings.saveChanges': 'Änderungen speichern',
  'settings.dataExported': 'Daten erfolgreich exportiert',

  // Tabs
  'settings.tabs.profile': 'Profil',
  'settings.tabs.preferences': 'Präferenzen',
  'settings.tabs.notifications': 'Benachrichtigungen',
  'settings.tabs.account': 'Konto & Plan',

  // Profile
  'settings.profile.changePhoto': 'Foto ändern',
  'settings.profile.photoHint': 'JPG, PNG oder GIF (max. 2MB)',
  'settings.profile.uploading': 'Wird hochgeladen...',
  'settings.profile.photoUpdated': 'Profilfoto aktualisiert!',
  'settings.profile.name': 'Name',
  'settings.profile.email': 'E-Mail',
  'settings.profile.phone': 'Telefon',
  'settings.profile.changePassword': 'Passwort ändern',
  'settings.profile.currentPassword': 'Aktuelles Passwort',
  'settings.profile.newPassword': 'Neues Passwort',
  'settings.profile.confirmPassword': 'Passwort bestätigen',

  // Preferences
  'settings.preferences.language': 'Sprache',
  'settings.preferences.chooseLanguage': 'Sprache wählen',
  'settings.preferences.timezone': 'Zeitzone',
  'settings.preferences.currency': 'Währung',

  // Notifications
  'settings.notifications.emailTitle': 'E-Mail-Benachrichtigungen',
  'settings.notifications.email.analysis': 'Analyse abgeschlossen',
  'settings.notifications.email.analysisDesc': 'E-Mail erhalten, wenn Ihre Analyse fertig ist',
  'settings.notifications.email.credits': 'Credit-Updates',
  'settings.notifications.email.creditsDesc': 'Benachrichtigungen über Credits und Zurücksetzungen',
  'settings.notifications.email.billing': 'Rechnungen & Zahlungen',
  'settings.notifications.email.billingDesc': 'Benachrichtigungen über Rechnungen und Planänderungen',
  'settings.notifications.email.newsletter': 'Newsletter',
  'settings.notifications.email.newsletterDesc': 'Tipps, Updates und neue Funktionen',
  'settings.notifications.pushTitle': 'Push-Benachrichtigungen',
  'settings.notifications.push.analysis': 'Analyse abgeschlossen',
  'settings.notifications.push.analysisDesc': 'Browser-Benachrichtigung, wenn Analyse fertig ist',
  'settings.notifications.push.credits': 'Credit-Warnungen',
  'settings.notifications.push.creditsDesc': 'Warnung bei niedrigem Credit-Kontostand',

  // Account
  'settings.account.currentSubscription': 'Aktuelles Abonnement',
  'settings.account.plan': 'Plan',
  'settings.account.price': 'Preis',
  'settings.account.nextBilling': 'Nächste Abrechnung',
  'settings.account.manageSubscription': 'Abonnement & Zahlungen verwalten',
  'settings.account.dataPrivacy': 'Daten & Privatsphäre',
  'settings.account.exportData': 'Daten exportieren',
  'settings.account.deleteAccount': 'Konto löschen',

  // Delete Modal
  'settings.deleteModal.title': 'Konto löschen?',
  'settings.deleteModal.subtitle': 'Alle Daten werden dauerhaft gelöscht.',
  'settings.deleteModal.warning1': 'Alle Analysen und Daten werden gelöscht',
  'settings.deleteModal.warning2': 'Aktives Abonnement wird sofort gekündigt',
  'settings.deleteModal.warning3': 'Keine Rückerstattung möglich',
  'settings.deleteModal.confirmLabel': 'Geben Sie "{{word}}" ein, um zu bestätigen *',
  'settings.deleteModal.cancel': 'Abbrechen',
  'settings.deleteModal.confirm': 'Konto löschen',

  // ─── Subscription & Billing ─────────────────────────────
  'sub.backToOverview': 'Zurück zur Übersicht',
  'sub.settings': 'Einstellungen',
  'sub.title': 'Abonnement & Abrechnung',
  'sub.subtitle': 'Verwalten Sie Ihr Abonnement, Ihre Zahlungsmethoden und Rechnungen',
  'sub.tab.overview': 'Übersicht',
  'sub.tab.payment': 'Zahlungsmethoden',
  'sub.tab.billing': 'Rechnungsadresse',
  'sub.tab.history': 'Zahlungshistorie',
  'sub.memberSince': 'Mitglied seit',
  'sub.perMonth': 'pro Monat',
  'sub.baseCHF': '(CHF {{amount}} Basis)',
  'sub.nextBilling': 'Nächste Abrechnung',
  'sub.creditsUsed': 'Verwendete Credits',
  'sub.paymentMethod': 'Zahlungsmethode',
  'sub.creditUsage': 'Credit-Nutzung',
  'sub.changePlan': 'Plan ändern',
  'sub.manageBilling': 'Rechnungen verwalten',
  'credits.topup.buyMore': 'Mehr Credits kaufen',
  'sub.reactivate': 'Reaktivieren',
  'sub.cancelSub': 'Abonnement kündigen',
  'sub.manageCards': 'Karten verwalten',
  'sub.downloadInvoices': 'Rechnungen herunterladen',
  'sub.invoicesAvailable': '{{count}} Rechnungen als PDF verfügbar',
  'sub.accountSettings': 'Kontoeinstellungen',
  'sub.profileNotifications': 'Profil, Benachrichtigungen & mehr',
  // Prices in EUR info
  'sub.eurInfo': 'Preise angezeigt in',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Kurs:',
  'sub.currentRate': 'Aktueller Kurs',
  // Payment Methods
  'sub.savedCards': 'Gespeicherte Karten',
  'sub.newCard': 'Neue Karte',
  'sub.default': 'Standard',
  'sub.setDefault': 'Als Standard festlegen',
  'sub.validUntil': 'Gültig bis',
  'sub.noCards': 'Keine Karten gespeichert',
  'sub.addFirstCard': 'Erste Karte hinzufügen',
  'sub.securePayments': 'Sichere Zahlungen',
  'sub.securePaymentsDesc': 'Alle Zahlungsdaten werden verschlüsselt übertragen und sicher bei unserem Zahlungsanbieter gespeichert. Wir speichern keine vollständigen Kartennummern.',
  // Billing Address
  'sub.billingAddress': 'Rechnungsadresse',
  'sub.edit': 'Bearbeiten',
  'sub.name': 'Name',
  'sub.streetAddress': 'Straße & Nr.',
  'sub.zip': 'PLZ',
  'sub.city': 'Stadt',
  'sub.country': 'Land',
  'sub.address': 'Adresse',
  'sub.save': 'Speichern',
  'sub.cancel': 'Abbrechen',
  'sub.country.switzerland': 'Schweiz',
  'sub.country.germany': 'Deutschland',
  'sub.country.austria': 'Österreich',
  'sub.country.netherlands': 'Niederlande',
  'sub.country.belgium': 'Belgien',
  // Payment History
  'sub.paymentHistory': 'Zahlungshistorie',
  'sub.allInvoicesPDF': 'Alle Rechnungen als PDF mit Logo herunterladen',
  'sub.downloadAll': 'Alle herunterladen',
  'sub.eurInvoiceNote': 'Rechnungen werden immer in CHF ausgestellt. Angezeigte EUR-Beträge dienen nur als Referenz.',
  'sub.date': 'Datum',
  'sub.description': 'Beschreibung',
  'sub.net': 'Netto',
  'sub.vat': 'MwSt.',
  'sub.total': 'Gesamt',
  'sub.status': 'Status',
  'sub.pdf': 'PDF',
  'sub.invoices': 'Rechnungen',
  'sub.totalAmount': 'Gesamtbetrag',
  // Change Plan Modal
  'sub.changePlanTitle': 'Plan ändern',
  'sub.current': 'Aktuell',
  'sub.month': '/Monat',
  'sub.showLess': 'Weniger anzeigen',
  'sub.showMore': '+{{count}} weitere',
  'sub.switchPlan': 'Plan wechseln',
  'sub.eurPriceNote': 'Preise in EUR angezeigt ({{note}}). Abrechnung erfolgt in CHF.',
  // Cancel Modal
  'sub.cancelTitle': 'Abonnement wirklich kündigen?',
  'sub.cancelIrreversible': 'Diese Aktion kann nicht rückgängig gemacht werden.',
  'sub.cancelWarning1': 'Alle verbleibenden Credits verfallen',
  'sub.cancelWarning2': 'Herabstufung zum Free-Plan',
  'sub.cancelWarning3': 'Verlust aller Premium-Funktionen',
  'sub.pauseInstead': 'Alternativ: Abonnement pausieren?',
  'sub.pauseDesc': 'Pausieren Sie Ihr Abonnement stattdessen und behalten Sie Ihre Daten.',
  'sub.preferPause': 'Pausieren bevorzugen',
  'sub.cancelReason': 'Kündigungsgrund',
  'sub.selectReason': 'Bitte auswählen...',
  'sub.reason.tooExpensive': 'Zu teuer',
  'sub.reason.notUsing': 'Nicht ausreichend genutzt',
  'sub.reason.missingFeatures': 'Fehlende Funktionen',
  'sub.reason.foundAlternative': 'Alternative gefunden',
  'sub.reason.other': 'Sonstiges',
  'sub.confirmType': 'Bestätigung: Geben Sie "CANCEL" ein *',
  'sub.cancelNow': 'Jetzt kündigen',
  // Add Card Modal
  'sub.addCardTitle': 'Neue Karte hinzufügen',
  'sub.cardHolder': 'Karteninhaber *',
  'sub.cardNumber': 'Kartennummer *',
  'sub.expiryDate': 'Ablaufdatum *',
  'sub.addCard': 'Karte hinzufügen',
  // Change Card Modal
  'sub.choosePayment': 'Zahlungsmethode wählen',
  'sub.active': 'Aktiv',
  'sub.close': 'Schließen',
  // Toast messages
  'sub.toast.cancelled': 'Ihr Abonnement wurde zum Ende des Abrechnungszeitraums gekündigt.',
  'sub.toast.reactivated': 'Ihr Abonnement wurde erfolgreich reaktiviert!',
  'sub.toast.planChanged': 'Plan erfolgreich zu {{plan}} geändert!',
  'sub.toast.defaultChanged': 'Standardzahlungsmethode geändert.',
  'sub.toast.cannotDeleteDefault': 'Die Standardkarte kann nicht gelöscht werden.',
  'sub.toast.cardRemoved': 'Karte wurde entfernt.',
  'sub.toast.fillAll': 'Bitte füllen Sie alle Felder aus.',
  'sub.toast.cardAdded': 'Neue Karte erfolgreich hinzugefügt!',
  'sub.toast.billingSaved': 'Rechnungsadresse gespeichert.',
  'sub.toast.invoiceDownloaded': 'Rechnung {{id}} heruntergeladen!',
  'sub.toast.pdfError': 'Fehler beim Erstellen der PDF.',
  // Chat interface
  'sub.notEnoughCredits': 'Nicht genügend Credits',
  'sub.needCredits': 'Sie benötigen mindestens {{count}} Credits pro Frage.',
  'sub.creditsLow': 'Credits werden knapp',
  'sub.questionsLeft': '{{count}} Fragen möglich.',
  'sub.plan': 'Plan',
  'sub.base': 'Basis',
  'sub.unlimited': 'Unbegrenzt',
  'sub.status.active': 'Aktiv',
  'sub.status.cancelled': 'Gekündigt',
  'sub.status.paused': 'Pausiert',
  'sub.invoice': 'RECHNUNG',
  'sub.from': 'VON',
  'sub.to': 'AN',
  'sub.vatId': 'MwSt.-Nr.',
  'sub.tel': 'Tel',
  'sub.invoiceDate': 'Rechnungsdatum',
  'sub.invoiceNumber': 'Rechnungsnummer',
  'sub.paymentStatus': 'Zahlungsstatus',
  'sub.creditCard': 'Kreditkarte',
  'sub.quantity': 'MENGE',
  'sub.price': 'PREIS',
  'sub.amount': 'BETRAG',
  'sub.subtotal': 'Zwischensumme',
  'sub.bank': 'Bank',
  'sub.card': 'Karte',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'Max Mustermann',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': 'Admin-Dashboard',
  'admin.subtitle': 'Kontrollzentrum',
  'admin.superAdmin': 'Super-Admin',
  'admin.logout': 'Abmelden',
  'admin.tabs.users': 'Benutzerverwaltung',
  'admin.tabs.downgrades': 'Herabstufungen',
  'admin.tabs.tips': 'Tipp des Tages',
  'admin.tabs.coupons': 'Gutscheincodes',
  'admin.tabs.website': 'Website-Editor',
  'admin.tabs.ai': 'KI-Einstellungen',
  'admin.tabs.transactions': 'Transaktionslog',
  'admin.tabs.stats': 'Statistiken',
  'admin.users.searchPlaceholder': 'Benutzer suchen (E-Mail oder Name)...',
  'admin.users.manageSubscription': 'Abonnement verwalten',
  'admin.users.grantFree': 'Kostenloses Konto gewähren',
  'admin.users.blockUser': 'Benutzer blockieren',
  'admin.users.cancellationPlaceholder': 'Warum wird das Abonnement gekündigt?',
  'admin.users.selectPlan': 'Plan auswählen',
  'admin.users.subChanged': 'Abonnement von {{name}} zu {{plan}} geändert',
  'admin.users.noReasonGiven': 'Kein Grund angegeben',
  'admin.users.subCancelled': 'Abonnement von {{name}} gekündigt (gültig bis {{date}})',
  'admin.users.paused': 'Pausiert',
  'admin.users.subPaused': 'Abonnement von {{name}} wurde pausiert',
  'admin.users.subReactivated': 'Abonnement von {{name}} wurde reaktiviert',
  'admin.users.freeAccount': 'Kostenloses Konto',
  'admin.users.blocked': 'Blockiert',
  'admin.users.cancelledExpiring': 'Gekündigt (ablaufend)',
  'admin.users.cancelledOn': 'Gekündigt:',
  'admin.users.endsOn': 'Endet:',
  'admin.users.daysRemaining': 'Tage verbleibend',
  'admin.users.expired': '(Abgelaufen)',
  'admin.users.total': 'Gesamt:',
  'admin.users.usersLabel': 'Benutzer',
  'admin.users.free': 'kostenlos',
  'admin.users.block': 'Blockieren',
  'admin.users.unblock': 'Entblockieren',
  'admin.users.unblockUser': 'Benutzer entblockieren',
  'admin.users.selectAction': 'Aktion auswählen',
  'admin.users.cancelSub': 'Abonnement kündigen',
  'admin.users.cancelSubDesc': 'Kündigung zum Monatsende',
  'admin.users.pauseSub': 'Abonnement pausieren',
  'admin.users.pauseSubDesc': 'Vorübergehende Pause',
  'admin.users.changePlan': 'Plan ändern',
  'admin.users.changePlanDesc': 'Zu einem anderen Plan wechseln',
  'admin.users.reactivateSub': 'Abonnement reaktivieren',
  'admin.users.reactivateDesc': 'Kündigung rückgängig machen',
  'admin.users.alreadyCancelled': 'Abonnement bereits gekündigt',
  'admin.users.planLabel': 'Plan',
  'admin.users.cancellationReasonOpt': 'Kündigungsgrund (optional)',
  'admin.users.cancelInfo1': 'Das Abonnement endet am',
  'admin.users.cancelInfo2': '(Monatsende). Bis dahin hat der Benutzer vollen Zugriff. Keine Rückerstattung.',
  'admin.users.newPlan': 'Neuer Plan',
  'admin.users.warning': 'Warnung',
  'admin.users.blockDesc': 'Der Benutzer wird sofort ausgeloggt und kann sich nicht wieder anmelden. Alle aktiven Sitzungen werden beendet.',
  'admin.users.confirmUnblock': 'Entblockierung bestätigen',
  'admin.users.unblockDesc': 'Der Benutzer kann sich wieder anmelden und alle Funktionen nutzen.',
  'admin.users.afterBlock': 'Nach der Blockierung:',
  'admin.users.afterUnblock': 'Nach der Entblockierung:',
  'admin.users.noAccountAccess': 'Kein Kontozugriff',
  'admin.users.noNewAnalyses': 'Keine neuen Analysen möglich',
  'admin.users.creditsStored': 'Credits und Verlauf bleiben gespeichert',
  'admin.users.accessRestored': 'Kontozugriff wiederhergestellt',
  'admin.users.allFeaturesAvail': 'Alle Funktionen wieder verfügbar',
  'admin.users.creditsPreserved': 'Credits und Verlauf bleiben erhalten',
  'admin.users.downgrade': 'Plan herabstufen',
  'admin.users.grantFreeBtn': 'Kostenlos gewähren',
  'admin.users.durationMonths': 'Dauer (Monate)',
  'admin.users.months': 'Monat(e)',
  'admin.users.freePlan': 'kostenlos',
  'admin.users.freeSummary': 'erhält',
  'admin.users.withCredits': 'mit',
  'admin.users.credits': 'Credits',
  'admin.users.subInfo': 'Abonnementinformationen',
  'admin.users.currentPlan': 'Aktueller Plan',
  'admin.users.joined': 'Beigetreten',
  'admin.users.totalSpent': 'Gesamtausgaben',
  'admin.users.paymentMethod': 'Zahlungsmethode',
  'admin.users.validThrough': 'Gültig bis',
  'admin.users.billingAddress': 'Rechnungsadresse',
  'admin.users.transactionHistory': 'Transaktionsverlauf',
  'admin.users.cancellationDate': 'Kündigungsdatum',
  'admin.users.validUntil': 'Gültig bis (Monatsende)',
  'admin.users.cancellationReason': 'Kündigungsgrund',
  'admin.users.noReason': 'Kein Grund angegeben',
  'admin.users.timeRemaining': 'Verbleibende Zeit',
  'admin.users.daysUntilDeactivation': 'Tage bis zur Deaktivierung',
  'admin.table.user': 'Benutzer',
  'admin.table.plan': 'Plan',
  'admin.table.subStatus': 'Abonnementstatus',
  'admin.table.cancellation': 'Kündigung',
  'admin.table.payment': 'Zahlungsmethode',
  'admin.table.spending': 'Ausgaben',
  'admin.table.actions': 'Aktionen',
  'admin.actions.viewDetails': 'Details anzeigen',
  'admin.actions.manageSubscription': 'Abonnement verwalten',
  'admin.actions.grantFree': 'Kostenlosen Zugang gewähren',
  'admin.actions.block': 'Benutzer blockieren',
  'admin.actions.unblock': 'Benutzer entblockieren',
  'admin.actions.cancel': 'Abbrechen',
  'admin.actions.save': 'Speichern',
  'admin.actions.delete': 'Löschen',
  'admin.actions.confirm': 'Bestätigen',
  'admin.actions.done': 'Fertig',
  'admin.actions.edit': 'Bearbeiten',
  'admin.actions.close': 'Schließen',
  'admin.table.status': 'Status',
  'admin.filter.all': 'Alle',
  'admin.subscription.active': 'Aktiv',
  'admin.subscription.cancelled': 'Gekündigt',
  'admin.subscription.paused': 'Pausiert',
  'admin.subscription.unknown': 'Unbekannt',
  'admin.status.active': 'Aktiv',
  'admin.status.inactive': 'Inaktiv',
  'admin.status.pending': 'Ausstehend',
  'admin.status.approved': 'Genehmigt',
  'admin.status.rejected': 'Abgelehnt',
  'admin.coupons.title': 'Gutscheinverwaltung',
  'admin.coupons.subtitle': 'Gutscheincodes erstellen und verwalten',
  'admin.coupons.newCoupon': 'Neuer Gutschein',
  'admin.coupons.registrationCoupons': 'Registrierungsgutscheine',
  'admin.coupons.trialCoupons': 'Testzugangs-Gutscheine',
  'admin.coupons.type': 'Typ',
  'admin.coupons.plan': 'Plan',
  'admin.coupons.value': 'Wert',
  'admin.coupons.usage': 'Nutzung',
  'admin.coupons.validUntil': 'Gültig bis',
  'admin.coupons.created': 'Erstellt',
  'admin.coupons.actions': 'Aktionen',
  'admin.coupons.copyCode': 'Code kopieren',
  'admin.coupons.allPlans': 'Alle Pläne',
  'admin.coupons.discount': 'Rabatt',
  'admin.coupons.days': 'Tage',
  'admin.coupons.months': 'Monate',
  'admin.coupons.free': 'kostenlos',
  'admin.coupons.unlimited': 'Unbegrenzt',
  'admin.coupons.createRegistration': 'Registrierungsgutschein erstellen',
  'admin.coupons.createTrial': 'Testzugangs-Gutschein erstellen',
  'admin.coupons.couponCode': 'Gutscheincode',
  'admin.coupons.codePlaceholder': 'z.B. NF-7X3K9M',
  'admin.coupons.generateCode': 'Neuen Code generieren',
  'admin.coupons.alertFillRequired': 'Bitte füllen Sie alle Pflichtfelder aus',
  'admin.coupons.alertSelectExpiry': 'Bitte wählen Sie ein Ablaufdatum oder aktivieren Sie "Unbegrenzte Gültigkeit"',
  'admin.coupons.alertCreateError': 'Fehler beim Erstellen des Gutscheins',
  'admin.coupons.confirmDelete': 'Sind Sie sicher, dass Sie diesen Gutschein löschen möchten?',
  'admin.coupons.discountPercent': 'Rabatt (%)',
  'admin.coupons.bonusCredits': 'Bonus-Credits',
  'admin.coupons.freeDuration': 'Kostenlose Dauer',
  'admin.coupons.maxUses': 'Max. Nutzungen',
  'admin.coupons.expiryDate': 'Ablaufdatum',
  'admin.coupons.unlimitedValidity': 'Unbegrenzte Gültigkeit',
  'admin.coupons.unlimitedUses': 'Unbegrenzte Nutzungen',
  'admin.coupons.trialCredits': 'Test-Credits',
  'admin.coupons.trialDuration': 'Testdauer',
  'admin.coupons.typePlaceholder': 'z.B. Early Bird, Partner, Influencer',
  'admin.coupons.duration': 'Dauer',
  'admin.stats.totalUsers': 'Gesamtbenutzer',
  'admin.stats.monthlyRevenue': 'Monatlicher Umsatz',
  'admin.stats.activeSubscriptions': 'Aktive Abonnements',
  'admin.stats.average': 'Durchschnitt',
  'admin.stats.revenuePerUser': 'Umsatz pro Benutzer',
  'admin.stats.grossRevenue': 'Bruttoumsatz',
  'admin.stats.net': 'NETTO',
  'admin.stats.netRevenue': 'Nettoumsatz',
  'admin.stats.churnRate': 'Kündigungsrate',
  'admin.stats.planDistribution': 'Planverteilung',
  'admin.stats.users': 'Benutzer',
  'admin.stats.revenueByPlan': 'Umsatz nach Plan',
  'admin.stats.recentActivity': 'Letzte Aktivitäten',
  'admin.stats.activity1': 'Thomas Weber hat auf Builder upgegradet',
  'admin.stats.activity2': 'Neuer Benutzer registriert',
  'admin.stats.activity3': 'Anna Schmidt hat auf Pro upgegradet',
  'admin.stats.hoursAgo2': 'vor 2 Stunden',
  'admin.stats.hoursAgo5': 'vor 5 Stunden',
  'admin.stats.dayAgo1': 'vor 1 Tag',
  'admin.stats.couponStats': 'Gutscheinstatistiken',
  'admin.stats.totalRedemptions': 'Gesamteinlösungen',
  'admin.stats.activeCoupons': 'Aktive Gutscheine',
  'admin.stats.registrationRedemptions': 'Registrierungseinlösungen',
  'admin.stats.trialRedemptions': 'Testeinlösungen',
  'admin.stats.couponDistribution': 'Gutscheinverteilung',
  'admin.stats.registrationCoupons': 'Registrierungsgutscheine',
  'admin.stats.trialCoupons': 'Testgutscheine',
  'admin.stats.expiredInactive': 'Abgelaufen/Inaktiv',
  'admin.stats.topCoupons': 'Top-Gutscheine nach Einlösungen',
  'admin.stats.redemptions': 'Einlösungen',
  'admin.stats.noCouponsRedeemed': 'Noch keine Gutscheine eingelöst',
  'admin.downgrade.pending': 'ausstehend',
  'admin.downgrade.refunds': 'Rückerstattungen',
  'admin.downgrade.sectionRequests': 'Anfragen',
  'admin.downgrade.sectionStats': 'Statistiken',
  'admin.downgrade.sectionRules': 'Regeln',
  'admin.downgrade.pendingRequests': 'Ausstehende Anfragen',
  'admin.downgrade.approvedRequests': 'Genehmigte Anfragen',
  'admin.downgrade.rejectedRequests': 'Abgelehnte Anfragen',
  'admin.downgrade.activeRules': 'Aktive Regeln',
  'admin.downgrade.autoRules': 'Automatische Herabstufungsregeln',
  'admin.downgrade.autoRulesDesc': 'Erstellen Sie Regeln, die basierend auf dem Nutzungsverhalten automatisch Herabstufungen auslösen',
  'admin.downgrade.newRule': 'Neue Regel',
  'admin.downgrade.totalRules': 'Regeln insgesamt',
  'admin.downgrade.triggeredActions': 'Ausgelöste Aktionen',
  'admin.downgrade.conditionsAnd': 'Bedingungen (UND-verknüpft)',
  'admin.downgrade.action': 'Aktion',
  'admin.downgrade.successTitle': 'Herabstufung erfolgreich!',
  'admin.downgrade.successDesc': 'Der Benutzer wurde erfolgreich herabgestuft und die Rückerstattung wurde bearbeitet.',
  'admin.downgrade.closing': 'Schließen...',
  'admin.downgrade.title': 'Benutzer herabstufen',
  'admin.downgrade.currentPlan': 'Aktueller Plan',
  'admin.downgrade.spending': 'Ausgaben',
  'admin.downgrade.availablePlans': 'Verfügbare Pläne für Herabstufung',
  'admin.downgrade.perMonth': 'pro Monat',
  'admin.downgrade.refundCalc': 'Rückerstattungsberechnung',
  'admin.downgrade.currentPlanLabel': 'Aktueller Plan',
  'admin.downgrade.newPlan': 'Neuer Plan',
  'admin.downgrade.remainingDays': 'Verbleibende Tage',
  'admin.downgrade.daysOf': '15 von 30 Tagen',
  'admin.downgrade.proRataRefund': 'Pro-rata Rückerstattung',
  'admin.downgrade.importantNote': 'Wichtiger Hinweis',
  'admin.downgrade.warningDesc': 'Die Herabstufung wird sofort ausgeführt. Der Benutzer verliert den Zugriff auf Premium-Funktionen und überschüssige Credits werden entfernt.',
  'admin.downgrade.processing': 'Wird verarbeitet...',
  'admin.downgrade.execute': 'Herabstufung ausführen',
  'admin.downgrade.notification': 'Benachrichtigung',
  'admin.downgrade.noNotification': 'Keine Benachrichtigung',
  'admin.downgrade.daysPeriod': 'Tage Gnadenfrist',
  'admin.downgrade.created': 'Erstellt:',
  'admin.downgrade.triggered': 'ausgelöst',
  'admin.downgrade.noRules': 'Noch keine Regeln erstellt',
  'admin.downgrade.createFirstRule': 'Erste Regel erstellen',
  'admin.downgrade.editRule': 'Regel bearbeiten',
  'admin.downgrade.createRule': 'Neue Regel erstellen',
  'admin.downgrade.ruleName': 'Regelname',
  'admin.downgrade.description': 'Beschreibung',
  'admin.downgrade.allConditions': 'Bedingungen (alle müssen erfüllt sein)',
  'admin.downgrade.addCondition': 'Bedingung hinzufügen',
  'admin.downgrade.type': 'Typ',
  'admin.downgrade.value': 'Wert',
  'admin.downgrade.fromPlan': 'Von Plan',
  'admin.downgrade.toPlan': 'Zu Plan',
  'admin.condition.inactivity': 'Inaktivität',
  'admin.condition.creditUsage': 'Credit-Nutzung',
  'admin.condition.loginFrequency': 'Anmeldehäufigkeit',
  'admin.condition.featureUsage': 'Funktionsnutzung',
  'admin.condition.supportTickets': 'Support-Tickets',
  'admin.operator.lessThan': 'weniger als',
  'admin.operator.greaterThan': 'mehr als',
  'admin.operator.equals': 'genau',
  'admin.operator.between': 'zwischen',
  'admin.unit.days': 'Tage',
  'admin.unit.perMonth': 'pro Monat',
  'admin.unit.count': 'Anzahl',
  'admin.transactions.all': 'Alle Transaktionen',
  'admin.transactions.allCards': 'Alle Karten',
  'admin.transactions.notFound': 'Keine Transaktionen gefunden',
  'admin.transactions.totalLabel': 'Gesamt',
  'admin.transactions.transactions': 'Transaktionen',
  'admin.tips.title': 'Tipp des Tages',
  'admin.tips.subtitle': 'Erstellen und verwalten Sie Tipps, die allen Benutzern angezeigt werden',
  'admin.tips.active': 'Aktiv',
  'admin.tips.currentlyShown': 'Dieser Tipp wird derzeit allen Benutzern angezeigt',
  'admin.tips.createNew': 'Neuen Tipp erstellen',
  'admin.tips.generating': 'Wird generiert...',
  'admin.tips.generateAI': 'KI-Tipp generieren',
  'admin.tips.titleLabel': 'Titel',
  'admin.tips.titlePlaceholder': 'z.B. Tipp des Tages',
  'admin.tips.category': 'Kategorie',
  'admin.tips.categoryTip': 'Tipp',
  'admin.tips.categoryFeature': 'Neue Funktion',
  'admin.tips.categoryProductivity': 'Produktivität',
  'admin.tips.categoryUpdate': 'Update',
  'admin.tips.content': 'Inhalt',
  'admin.tips.contentPlaceholder': 'Schreiben Sie Ihren Tipp für Benutzer hier...',
  'admin.tips.addTip': 'Tipp hinzufügen',
  'admin.tips.allTips': 'Alle Tipps',
  'admin.tips.noTips': 'Noch keine Tipps erstellt',
  'admin.tips.noTipsHint': 'Klicken Sie auf "KI-Tipp generieren", um zu beginnen',
  'admin.noData': 'Keine Daten verfügbar',
  'admin.range.7d': '7 Tage',
  'admin.range.30d': '30 Tage',
  'admin.range.90d': '90 Tage',
  'admin.range.1y': '1 Jahr',
  'admin.actions.saveSettings': 'Einstellungen speichern',
  'admin.actions.create': 'Erstellen',
  'admin.downgrade.sectionReports': 'Berichte',
  'admin.downgrade.settings': 'Herabstufungseinstellungen',
  'admin.downgrade.autoApprove': 'Automatische Genehmigung',
  'admin.downgrade.autoApproveDesc': 'Herabstufungsanfragen automatisch genehmigen',
  'admin.downgrade.refundPolicy': 'Rückerstattungsrichtlinie',
  'admin.downgrade.prorata': 'Pro-rata Rückerstattung',
  'admin.downgrade.prorataDesc': 'Proportionale Rückerstattung basierend auf verbleibenden Tagen',
  'admin.downgrade.fullRefund': 'Volle Rückerstattung',
  'admin.downgrade.fullRefundDesc': 'Vollständige Rückerstattung der Preisdifferenz',
  'admin.downgrade.noRefund': 'Keine Rückerstattung',
  'admin.downgrade.noRefundDesc': 'Herabstufung ohne Rückerstattung',
  'admin.downgrade.daysRemaining15': '(mit 15 verbleibenden Tagen)',
  'admin.downgrade.requestsTitle': 'Herabstufungsanfragen',
  'admin.downgrade.approvalRate': 'Genehmigungsrate',
  'admin.downgrade.mostCommonTransition': 'Häufigster Übergang',
  'admin.downgrade.mostCommonReason': 'Häufigster Grund',
  'admin.downgrade.avgProcessingTime': 'Durchschnittliche Bearbeitungszeit',
  'admin.downgrade.avgTimeDesc': 'Durchschnittliche Zeit bis zur Entscheidung',
  'admin.downgrade.totalRefunds': 'Rückerstattungen insgesamt',
  'admin.downgrade.pendingRefunds': 'Ausstehende Rückerstattungen',
  'admin.downgrade.summary': 'Zusammenfassung',
  'admin.downgrade.total': 'Gesamt',
  'admin.downgrade.csvDesc': 'Für Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'Als CSV herunterladen',
  'admin.downgrade.jsonDesc': 'Für Entwickler, APIs',
  'admin.downgrade.downloadJSON': 'Als JSON herunterladen',
  'admin.downgrade.exportInfo': 'Der Export enthält',
  'admin.downgrade.entries': 'Einträge aus dem ausgewählten Zeitraum',
  'admin.downgrade.topReasons': 'Häufigste Herabstufungsgründe',
  'admin.downgrade.refundHistory': 'Rückerstattungsverlauf',
  'admin.downgrade.noRefunds': 'Noch keine Rückerstattungen',
  'admin.downgrade.statistics': 'Herabstufungsstatistiken',
  'admin.downgrade.requests': 'Anfragen',
  'admin.downgrade.monthlyTrend': 'Monatlicher Trend',
  'admin.downgrade.planTransitions': 'Planübergänge',
  'admin.downgrade.trend': 'Trend (vs. Vormonat)',
  'admin.downgrade.trendDesc': 'Weniger Herabstufungen = besser',
  'admin.coupons.allPlansUniversal': 'Alle Pläne (Universell)',
  'admin.coupons.onlyStarter': 'Nur Starter',
  'admin.coupons.onlyPro': 'Nur Pro',
  'admin.coupons.onlyBuilder': 'Nur Builder',
  'admin.coupons.allPlansHint': 'Wählen Sie "Alle Pläne" für einen universellen Gutschein',
  'admin.coupons.discountOptional': 'Rabatt % (optional)',
  'admin.coupons.discountPlaceholder': 'z.B. 50 für 50% Rabatt',
  'admin.coupons.bonusCreditsOptional': 'Bonus-Credits (optional)',
  'admin.coupons.bonusCreditsPlaceholder': 'z.B. 500',
  'admin.coupons.freeDurationOptional': 'Kostenlose Dauer (optional)',
  'admin.coupons.durationPlaceholder': 'z.B. 30',
  'admin.coupons.freeDurationHint': 'z.B. 30 Tage kostenlose Nutzung',
  'admin.coupons.noLimit': 'Keine Nutzungsbeschränkung',
  'admin.coupons.noExpiry': 'Kein Ablaufdatum',
  'admin.coupons.creditsPlaceholder': 'z.B. 100',
  'admin.coupons.creditsHint': 'Anzahl der Credits für den Testzugang',
  'admin.coupons.trialDurationHint': 'Wie lange der Testzugang gültig ist',
  'admin.coupons.autoCalculated': 'Automatisch aus der Testdauer berechnet',
  'admin.websiteEditor.title': 'Website-Editor',
  'admin.websiteEditor.subtitle': 'Bearbeiten Sie alle Abschnitte der Homepage',
  'admin.websiteEditor.openPreview': 'Vorschau öffnen',
  'admin.websiteEditor.group.structure': 'Seitenstruktur',
  'admin.websiteEditor.group.design': 'Design & Layout',
  'admin.websiteEditor.group.settings': 'Einstellungen',
  'admin.websiteEditor.tab.navbar': 'Navigation',
  'admin.websiteEditor.tab.howitworks': 'So funktioniert es',
  'admin.websiteEditor.tab.about': 'Über uns',
  'admin.websiteEditor.tab.pricing': 'Preise',
  'admin.websiteEditor.tab.sections': 'Abschnitte',
  'admin.websiteEditor.tab.media': 'Medien',
  'admin.websiteEditor.tab.chatwidget': 'Mit uns sprechen',
  'admin.websiteEditor.tab.invoice': 'Rechnungen',
  'admin.websiteEditor.tab.legal': 'Rechtliches',
  'admin.websiteEditor.tab.seo': 'SEO Basis',
  'admin.websiteEditor.tab.advancedseo': 'SEO Erweitert',
  'admin.websiteEditor.tab.versions': 'Versionen',
  'admin.hero.title': 'Hero-Bereich bearbeiten',
  'admin.hero.subtitle': 'Texte, Buttons und Statistiken der Homepage',
  'admin.hero.reset': 'Zurücksetzen',
  'admin.hero.save': 'Speichern',
  'admin.hero.savedMsg': 'Hero-Daten gespeichert!',
  'admin.hero.badge': 'Badge-Text',
  'admin.hero.headings': 'Überschriften',
  'admin.hero.line1White': 'Zeile 1 (weiß)',
  'admin.hero.line2Gold': 'Zeile 2 (gold)',
  'admin.hero.subtitleSection': 'Untertitel',
  'admin.hero.line1': 'Zeile 1',
  'admin.hero.line2': 'Zeile 2',
  'admin.hero.buttons': 'Buttons',
  'admin.hero.primaryBtn': 'Primärer Button (gold)',
  'admin.hero.secondaryBtn': 'Sekundärer Button (Umrandung)',
  'admin.hero.stats': 'Statistiken',
  'admin.hero.statN': 'Statistik {{n}}',
  'admin.hero.value': 'Wert',
  'admin.hero.label': 'Bezeichnung',
  'admin.hero.previewNote': 'Änderungen werden nach dem Speichern auf der Homepage sichtbar. Laden Sie die Seite neu, um die Vorschau zu sehen.',

  // Idea History
  'history.title': 'Ideenverlauf',
  'history.countLabel': '{{count}} Analysen',
  'history.recentLabel': 'Ihre letzten Analysen',
  'history.exportAll': 'Alle exportieren',
  'history.metrics.marketSize': 'Marktgröße',
  'history.metrics.competition': 'Wettbewerb',
  'history.metrics.startingCapital': 'Startkapital',
  'history.metrics.timeToMarket': 'Time-to-Market',
  'history.metrics.profitPotential': 'Gewinnpotenzial',
  'history.metrics.scalability': 'Skalierbarkeit',
  'history.summary.title': 'Zusammenfassung',
  'history.download': 'Herunterladen',
  'history.downloadJSON': 'Als JSON speichern',
  'history.downloadTXT': 'Als TXT speichern',
  'history.downloadPDF': 'Als PDF speichern',
  'history.fullAnalysis': 'Vollständige Analyse',
  'history.searchPlaceholder': 'Nach Titel oder Tags suchen...',
  'history.filterAll': 'Alle Bewertungen',
  'history.loading': 'Analysen werden geladen...',
  'history.noResults': 'Keine Ergebnisse gefunden',
  'history.empty': 'Noch keine Analysen',
  'history.emptyHint': 'Starten Sie eine Analyse im KI-Assistenten',
  'history.delete': 'Löschen',
  'history.cancel': 'Abbrechen',
  'history.deleteModalTitle': 'Analyse löschen?',
  'history.deleteModalDesc': '"{{title}}" wird dauerhaft gelöscht.',
  'history.errorLoading': 'Fehler beim Laden der Analysen',
  'history.deleteSuccess': 'Analyse erfolgreich gelöscht',
  'history.deleteError': 'Fehler beim Löschen der Analyse',
  'history.jsonExported': 'JSON exportiert',
  'history.txtExported': 'TXT exportiert',
  'history.allExported': '{{count}} Ideen exportiert',
  'history.analysisHeader': 'IDEENANALYSE',
  'history.titleLabel': 'Titel',
  'history.ratingLabel': 'Bewertung',
  'history.dateLabel': 'Datum',
  'history.creditsLabel': 'Credits',
  'history.analysisSection': 'Analyse',

  // Overview
  'overview.title': 'Übersicht',
  'overview.last24h': 'Letzte 24 Stunden',
  'overview.analysesToday': 'Analysen heute',
  'overview.totalAnalyses': 'Analysen insgesamt',
  'overview.successRate': 'Erfolgsquote',
  'overview.topRatings': 'Top-Bewertungen',
  'overview.recentActivity': 'Letzte Aktivitäten',
  'overview.viewAll': 'Alle anzeigen',
  'overview.quickAccess': 'Schnellzugriff',
  'overview.quick.newAnalysis': 'Neue Analyse starten',
  'overview.quick.newAnalysisDesc': 'Starten Sie eine neue KI-gestützte Nischenanalyse',
  'overview.quick.myAnalyses': 'Meine Analysen',
  'overview.quick.myAnalysesDesc': 'Alle vorherigen Analysen anzeigen',
  'overview.quick.buyCredits': 'Credits kaufen',
  'overview.quick.buyCreditsDesc': 'Mehr Credits für mehr Analysen',
  'overview.quick.settings': 'Einstellungen',
  'overview.quick.settingsDesc': 'Profil und Präferenzen anpassen',
  'overview.unlimitedCredits': 'Unbegrenzte Credits verfügbar',
  'overview.creditsAvailable': 'Credits verfügbar',
  'overview.upgradePlan': 'Plan upgraden',
  'overview.buyCredits': 'Credits kaufen',
  'overview.creditUsage': 'Credit-Nutzung diesen Monat',
  'overview.available': 'verfügbar',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': 'Upgrades',
  'admin.transactions.downgrades': 'Downgrades',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}} hat jetzt {{months}} Monat(e) kostenlosen {{plan}}-Plan',
  'admin.users.blockSuccess': '{{name}} wurde blockiert',
  'admin.users.unblockSuccess': '{{name}} wurde entblockiert',
  'admin.users.removeFreeSuccess': 'Kostenloser Status von {{name}} wurde entfernt',

  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Free',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Neue Funktion entdecken',
  'admin.tips.productivityBoost': 'Produktivitäts-Boost',
  'admin.tips.importantUpdate': 'Wichtiges Update',
  'admin.tips.tipOfDay': 'Tipp des Tages',

  'admin.actions.activate': 'Aktivieren',
  'admin.actions.deactivate': 'Deaktivieren',
  'admin.websiteEditor.tab.features': 'Funktionen',
  'admin.websiteEditor.tab.testimonials': 'Testimonials',
  'admin.websiteEditor.tab.faq': 'FAQ',
  'admin.websiteEditor.tab.cta': 'CTA',
  'admin.websiteEditor.tab.footer': 'Footer',
  'admin.websiteEditor.tab.design': 'Design',
  'admin.websiteEditor.tab.customcode': 'Benutzerdefinierter Code',
  'admin.websiteEditor.tab.socials': 'Soziale Medien',
  'admin.websiteEditor.tab.importexport': 'Import/Export',

  // --- AI Settings Editor ---
  'admin.ai.title': 'KI-Assistent-Einstellungen',
  'admin.ai.subtitle': 'Verhalten, Stil und Analysetiefe konfigurieren',
  'admin.ai.smartWeightingActive': 'Intelligente Gewichtung aktiv',
  'admin.ai.smartWeightingDesc': 'Die KI kombiniert automatisch alle Perspektiven mit intelligenter Gewichtung. Bei mehreren Presets wird das erste Preset stärker gewichtet (primäres Preset). Sie können die Gewichtung auch manuell anpassen.',
  'admin.ai.modelTitle': 'IdeaVerdict KI-Modell',
  'admin.ai.modelSubtitle': 'Wählen Sie die KI-Engine für alle Benutzeranalysen',
  'admin.ai.activeModel': 'Aktives Modell:',
  'admin.ai.activeModelDesc': 'Alle Benutzer erhalten Antworten von diesem Modell.',
  'admin.ai.recommendations': 'Empfehlungen für optimale Ergebnisse',
  'admin.ai.new': 'NEU',
  'admin.ai.recommendationsDesc': 'Bewährte Preset-Kombinationen für beste Analysequalität',
  'admin.ai.recommendationsInfo': 'Diese Kombinationen wurden getestet und liefern die besten Ergebnisse. Klicken Sie auf eine Empfehlung, um sie direkt zu übernehmen.',
  'admin.ai.active': 'AKTIV',
  'admin.ai.apply': 'Übernehmen',
  'admin.ai.avoid': 'Vermeiden',
  'admin.ai.excellentQuality': 'Ausgezeichnete Qualität',
  'admin.ai.goodQuality': 'Gute Qualität',
  'admin.ai.poorQuality': 'Verwässerte Qualität - Nicht empfohlen',
  'admin.ai.proTips': 'Pro-Tipps',
  'admin.ai.tip1Title': '2 Presets sind optimal:',
  'admin.ai.tip1Desc': 'Klare Perspektive ohne Verwässerung',
  'admin.ai.tip2Title': 'Primäres Preset ist wichtig:',
  'admin.ai.tip2Desc': 'Das erste Preset hat den größten Einfluss',
  'admin.ai.tip3Title': 'Gegensätze vermeiden:',
  'admin.ai.tip3Desc': '"EXTREME" + "Creative" = widersprüchlich',
  'admin.ai.tip4Title': 'Maximal 3 Presets:',
  'admin.ai.tip4Desc': 'Bei 4+ Presets wird das Ergebnis zu allgemein',
  'admin.ai.warningManyPresets': 'Warnung: Viele Presets',
  'admin.ai.warningManyPresetsDesc': 'Sie haben {{count}} Presets ausgewählt. Dies kann das Ergebnis verwässern.',
  'admin.ai.warningRecommend': 'Empfohlen: Maximal 2-3 Presets',
  'admin.ai.forOptimalResults': 'für optimale Ergebnisse.',
  'admin.ai.presets': 'Presets',
  'admin.ai.multiSelect': '(Mehrfachauswahl möglich)',
  'admin.ai.presetsDesc': 'Wählen Sie ein oder mehrere Presets. Das erste Preset ist das primäre Preset mit der höchsten Gewichtung.',
  'admin.ai.primaryPreset': 'Primäres Preset',
  'admin.ai.weightControl': 'Gewichtungskontrolle',
  'admin.ai.weightControlDesc': 'Passen Sie an, wie stark jedes Preset die Analyse beeinflusst',
  'admin.ai.manual': 'Manuell',
  'admin.ai.automatic': 'Automatisch',
  'admin.ai.autoWeightingActive': 'Automatische Gewichtung aktiv:',
  'admin.ai.autoWeightingDesc': 'Die Gewichtung wird automatisch basierend auf der Anzahl der Presets optimiert.',
  'admin.ai.primary': 'PRIMÄR',
  'admin.ai.totalWeight': 'Gesamt',
  'admin.ai.shouldBe100': 'sollte 100% sein',
  'admin.ai.normalize': 'Normalisieren',
  'admin.ai.combinedSettings': 'Kombinierte Einstellungen',
  'admin.ai.presetsCount': 'Presets',
  'admin.ai.strictness': 'Strenge',
  'admin.ai.realism': 'Realismus',
  'admin.ai.creativity': 'Kreativität',
  'admin.ai.detailLevel': 'Detaillierungsgrad',
  'admin.ai.customInstructions': 'Benutzerdefinierte Anweisungen',
  'admin.ai.customInstructionsDesc': 'Zusätzliche Anweisungen, die mit den Presets kombiniert werden',
  'admin.ai.customInstructionsPlaceholder': 'z.B. "Konzentriere dich auf den DACH-Markt", "Verwende immer konkrete Zahlen", "Vergleiche mit bestehenden Wettbewerbern", "Antworte immer mit Beispielen"...',
  'admin.ai.customInstructionsHint': 'Diese Anweisungen werden automatisch mit den ausgewählten Presets kombiniert.',
  'admin.ai.manualFinetuning': 'Manuelles Fine-Tuning',
  'admin.ai.manualFinetuningHint': '(optional, überschreibt Preset-Werte)',
  'admin.ai.manualFinetuningDesc': 'Passen Sie die kombinierten Werte manuell an, wenn Sie etwas feinabstimmen möchten.',
  'admin.ai.tone': 'Tonfall',
  'admin.ai.mild': 'Mild',
  'admin.ai.strict': 'Streng',
  'admin.ai.creative': 'Kreativ',
  'admin.ai.realistic': 'Realistisch',
  'admin.ai.conservative': 'Konservativ',
  'admin.ai.compact': 'Kompakt',
  'admin.ai.detailed': 'Detailliert',
  'admin.ai.responseLength': 'Antwortlänge',
  'admin.ai.short': 'Kurz & Bündig',
  'admin.ai.medium': 'Mittel',
  'admin.ai.long': 'Ausführlich',
  'admin.ai.focusAreas': 'Analysefokusbereiche',
  'admin.ai.autoRating': 'Automatische Bewertung',
  'admin.ai.autoRatingDesc': 'Jede Analyse erhält automatisch eine Bewertung (Gut/Mittel/Schlecht)',
  'admin.ai.showSources': 'Quellen anzeigen',
  'admin.ai.showSourcesDesc': 'Verweise auf Datenquellen und Marktdaten in Antworten',
  'admin.ai.hidePreview': 'Vorschau ausblenden',
  'admin.ai.showPreview': 'Vorschau anzeigen',
  'admin.ai.aiBehavior': 'KI-Verhalten',
  'admin.ai.length': 'Länge',
  'admin.ai.liveExample': 'Live-Beispiel',
  'admin.ai.testSettings': 'Testen Sie Ihre Einstellungen',
  'admin.ai.selectExampleQuestion': 'Beispielfrage auswählen:',
  'admin.ai.userAsks': 'Benutzer fragt:',
  'admin.ai.generating': 'KI generiert Antwort...',
  'admin.ai.generateExample': 'Beispielantwort generieren',
  'admin.ai.aiResponds': 'KI-Assistent antwortet:',
  'admin.ai.generateHint': 'Klicken Sie auf "Beispielantwort generieren", um zu sehen, wie die KI mit Ihren Einstellungen antwortet.',
  'admin.ai.reset': 'Zurücksetzen',
  'admin.ai.saved': 'Gespeichert!',
  'admin.ai.saveSettings': 'Einstellungen speichern',

  // --- Table headers ---
  'admin.coupons.code': 'Code',
  'admin.coupons.credits': 'Credits',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': 'Ausgewogene Analyse mit hoher Qualität. Die beste Wahl für die meisten Nischenbewertungen und Ideenvalidierungen.',
  'admin.ai.model.preciseAnalyses': 'Präzise Analysen',
  'admin.ai.model.bestBalance': 'Beste Balance',
  'admin.ai.model.recommended': 'Empfohlen',
  'admin.ai.model.fastDesc': 'Blitzschnelle Antworten für schnelle Nischenchecks, Brainstorming und erste Einschätzungen. Ideal wenn Geschwindigkeit zählt.',
  'admin.ai.model.fast': 'SCHNELL',
  'admin.ai.model.fastestResponses': 'Schnellste Antworten',
  'admin.ai.model.thinkingDesc': 'Tiefgehende Analyse mit fortgeschrittenem logischem Denken. Für komplexe Marktanalysen, kritische Bewertungen und strategische Planung.',
  'admin.ai.model.deepestAnalysis': 'Tiefste Analyse',
  'admin.ai.model.logicalThinking': 'Logisches Denken',
  'admin.ai.model.strategy': 'Strategie',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': 'Strenge Analyse',
  'admin.ai.preset.strict.desc': 'Kritisch, faktenbasiert, ohne Beschönigung. Deckt Schwächen gnadenlos auf.',
  'admin.ai.preset.extreme.name': 'EXTREME Analyse',
  'admin.ai.preset.extreme.desc': 'Maximale Strenge, gnadenlose Kritik, Fokus auf Worst-Case-Szenarien. Nur für harte Realitätschecks.',
  'admin.ai.preset.professional.name': 'Professionell',
  'admin.ai.preset.professional.desc': 'Objektiv, strukturiert, ausgewogen. Wie ein erfahrener Unternehmensberater.',
  'admin.ai.preset.realistic.name': 'Realistisch',
  'admin.ai.preset.realistic.desc': 'Ehrlich und praktisch. Fokus auf umsetzbare Umsetzung und reale Marktdaten.',
  'admin.ai.preset.creative.name': 'Kreativ & Motivierend',
  'admin.ai.preset.creative.desc': 'Inspirierend, ideenreich, positiv. Findet Chancen und unkonventionelle Wege.',
  'admin.ai.preset.balanced.name': 'Ausgewogen',
  'admin.ai.preset.balanced.desc': 'Gute Mischung aus Kritik und Motivation. Der Standardmodus.',
  'admin.ai.preset.investor.name': 'Investorenperspektive',
  'admin.ai.preset.investor.desc': 'Wie ein Risikokapitalgeber. Fokus auf Skalierung, ROI und Exit-Strategie.',
  'admin.ai.preset.startup-coach.name': 'Startup-Coach',
  'admin.ai.preset.startup-coach.desc': 'Praktischer Mentor für Gründer. Fokus auf schnelle Umsetzung und MVP.',
  'admin.ai.preset.market-researcher.name': 'Marktforscher',
  'admin.ai.preset.market-researcher.desc': 'Datengesteuert und analytisch. Tiefgehende Markt- und Wettbewerbsanalyse.',
  'admin.ai.preset.risk-analyst.name': 'Risikoanalyst',
  'admin.ai.preset.risk-analyst.desc': 'Fokus auf Risiken und Worst-Case-Szenarien. Für realistische Planung.',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': 'Marktanalyse',
  'admin.ai.focus.wettbewerb': 'Wettbewerb',
  'admin.ai.focus.monetarisierung': 'Monetarisierung',
  'admin.ai.focus.risiken': 'Risiken',
  'admin.ai.focus.finanzen': 'Finanzen',
  'admin.ai.focus.skalierung': 'Skalierung',
  'admin.ai.focus.innovation': 'Innovation',
  'admin.ai.focus.trends': 'Trends',
  'admin.ai.focus.differenzierung': 'Differenzierung',
  'admin.ai.focus.umsetzung': 'Umsetzung',
  'admin.ai.focus.zielgruppe': 'Zielgruppe',
  'admin.ai.focus.marketing': 'Marketing',

  // --- Tone Options ---
  'admin.ai.tone.direkt': 'Direkt & Schonungslos',
  'admin.ai.tone.professionell': 'Professionell & Sachlich',
  'admin.ai.tone.ehrlich': 'Ehrlich & Pragmatisch',
  'admin.ai.tone.motivierend': 'Motivierend & Positiv',
  'admin.ai.tone.freundlich': 'Freundlich & Unterstützend',
  'admin.ai.tone.akademisch': 'Akademisch & Analytisch',

  // --- Example Questions ---
  'admin.ai.question.niche': 'Welche profitable Nische empfehlen Sie?',
  'admin.ai.question.evaluate': 'Bewerten Sie meine Idee: Eine App für Hundehalter',
  'admin.ai.question.trends': 'Welche Trends haben gerade Potenzial?',
  'admin.ai.question.sharpen': 'Wie kann ich meine Nische schärfen?',

  'admin.ai.rec.bestCombination.title': '🏆 Beste Kombination (2 Presets)',
  'admin.ai.rec.bestCombination.desc': 'Kritisch aber konstruktiv, mit konkreten Handlungsschritten',
  'admin.ai.rec.bestCombination.useCase': 'Empfohlen für die meisten Analysen',

  'admin.ai.rec.balancedThree.title': '⚖️ Ausgewogen (3 Presets)',
  'admin.ai.rec.balancedThree.desc': 'Professionell, realistisch und investor:innenfreundlich',
  'admin.ai.rec.balancedThree.useCase': 'Für umfassende Geschäftsanalysen',

  'admin.ai.rec.creativeDriven.title': '💡 Kreativ & Motivierend (2 Presets)',
  'admin.ai.rec.creativeDriven.desc': 'Inspirierend mit praktischen Umsetzungstipps',
  'admin.ai.rec.creativeDriven.useCase': 'Für Ideenfindung und Brainstorming',

  'pdf.rating.good': 'Gut',
  'pdf.rating.bad': 'Schlecht',
  'pdf.rating.medium': 'Mittel',
  'pdf.header.subtitle': 'Analyseansicht',
  'pdf.footer.tagline': 'KI-gestützte Nischenvalidierung',
  'pdf.footer.page': 'Seite',
  'pdf.benchmark.title': 'BRANCHEN-BENCHMARK',
  'pdf.benchmark.yourScore': 'Dein Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKTANALYSE',
  'pdf.summary.title': 'ZUSAMMENFASSUNG',
  'pdf.structuredSummary.verdict': 'URTEIL',
  'pdf.disclaimer.body': 'Dieser Bericht wurde von einem KI-Modell erstellt und dient nur zu Informationszwecken. Er stellt keine finanzielle, rechtliche, steuerliche oder anlagebezogene Beratung dar. Marktdaten, Bewertungen und Prognosen sind KI-generierte Schätzungen und können unvollständig oder ungenau sein. Bitte überprüfen Sie alle Informationen unabhängig und konsultieren Sie qualifizierte Fachleute, bevor Sie geschäftliche oder Investitionsentscheidungen treffen. IdeaVerdict übernimmt keine Haftung für Handlungen, die auf Basis dieses Berichts vorgenommen werden.',
  'pdf.disclaimer.title': 'WICHTIGER HINWEIS',
  'pdf.closing.title': 'Erstellt von IdeaVerdict',
  'pdf.closing.subtitle': 'KI-gestützte Nischenvalidierung | Umfassende Marktintelligenz',
  'history.swot.title': 'SWOT-Analyse',
  'history.swot.strengths': 'Stärken',
  'history.swot.weaknesses': 'Schwächen',
  'history.swot.opportunities': 'Chancen',
  'history.swot.risks': 'Risiken',
  'history.sections.recommendations': 'Empfehlungen',
  'history.sections.marketAnalysis': 'Wettbewerbsanalyse',
  'history.sections.microAngles': 'Mikro-Nischen-Ansätze',
  'history.sections.improvements': 'Verbesserungsvorschläge',
  'history.sections.alternatives': 'Alternative Nischen',
  'history.sections.structuredSummary': 'Strukturierte Zusammenfassung (Builder)',
  'history.structuredSummary.strengths': 'Top-Stärken',
  'history.structuredSummary.risks': 'Top-Risiken',
  'history.structuredSummary.actions': 'Nächste Schritte',
  'history.sections.developerBriefing': 'Entwickler-Briefing (Builder)',
  'history.sections.conversation': 'Gesprächsverlauf',
  'history.conversation.user': 'Benutzer',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Strukturiertes Ergebnis',
  'admin.tabs.usage': 'Nutzung',
  'admin.usage.title': 'KI-Nutzung & Kostenanalyse',
  'admin.usage.refresh': 'Daten aktualisieren',
  'admin.usage.requests': 'Anfragen',
  'admin.usage.users': 'Nutzer',
  'admin.usage.totalTokens': 'Tokens gesamt',
  'admin.usage.apiCosts': 'API-Kosten',
  'admin.usage.revenue': 'Umsatz',
  'admin.usage.margin': 'Marge',
  'admin.usage.byModel': 'Nach Modell',
  'admin.usage.allModels': 'Alle Modelle',
  'admin.usage.searchEmail': 'Nach E-Mail-Adresse suchen...',
  'admin.usage.perPage': 'Pro Seite:',
  'admin.usage.loading': 'Nutzungsdaten werden geladen...',
  'admin.usage.noEntries': 'Keine Einträge für die aktuellen Filter gefunden.',
  'admin.usage.time': 'Zeitpunkt',
  'admin.usage.user': 'Benutzer',
  'admin.usage.model': 'Modell',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Dauer',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Zeige',
  'admin.usage.of': 'von',
  'admin.usage.entries': 'Einträgen',
  'admin.usage.firstPage': 'Erste Seite',
  'admin.usage.prevPage': 'Zurück',
  'admin.usage.page': 'Seite',
  'admin.usage.nextPage': 'Weiter',
  'admin.usage.lastPage': 'Letzte Seite',
  'admin.usage.requestDetails': 'Anfrage-Details',
  'admin.usage.close': 'Schließen',
  'admin.usage.loadingDetails': 'Details werden geladen...',
  'admin.usage.inputTokens': 'Input-Tokens',
  'admin.usage.outputTokens': 'Output-Tokens',
  'admin.usage.providerCost': 'Anbieter-Kosten',
  'admin.usage.providerBreakdown': 'Anbieter-Aufschlüsselung',
  'admin.usage.fullResponseData': 'Vollständige Antwortdaten',
  'admin.usage.entryNotFound': 'Dieser Eintrag konnte nicht geladen werden.',
  'admin.usage.today': 'Heute',
  'admin.usage.last7d': 'Letzte 7 Tage',
  'admin.usage.last30d': 'Letzte 30 Tage',
  'admin.usage.allTime': 'Gesamt',
  'admin.ai.fallbackModel': 'Fallback-Modell',
  'admin.ai.systemPrompts': 'System-Prompts',
  'admin.ai.fallbackModelDesc': 'Wird verwendet, wenn das primäre Modell fehlschlägt oder ungültige Ausgaben zurückgibt',
  'admin.ai.systemPromptsDesc': 'Schreibgeschützte Ansicht der Anweisungen, die jedes Modell erhält',
  'admin.ai.provider': 'Anbieter',
  'admin.ai.modelId': 'Modell-ID',
  'admin.ai.maxTokens': 'Max. Tokens',
  'admin.ai.temperature': 'Temperatur',
  'admin.ai.thinkingBudget': 'Thinking-Budget',
  'admin.ai.supportsThinking': 'Unterstützt Thinking',
  'admin.ai.displayName': 'Anzeigename',
  'admin.ai.precise': 'Präzise',
  'admin.ai.creativeTemp': 'Kreativ',

  // Header (Dashboard-Kopfzeile)
  'header.openMenu': 'Menü öffnen',
  'header.home': 'Startseite',
  'header.notifications': 'Benachrichtigungen',
  'header.settings': 'Einstellungen',
  'header.profile': 'Profil',

  // Seitenleiste
  'sidebar.collapse': 'Seitenleiste einklappen',
  'sidebar.expand': 'Seitenleiste ausklappen',
  'sidebar.close': 'Menü schließen',
  'sidebar.plan': 'Paket',
  'sidebar.backToWebsite': 'Zurück zur Website',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Impressum',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, Vereinigte Arabische Emirate (VAE)',
  'legal.imprint.seatLabel': 'Unternehmenssitz',
  'legal.imprint.seatBody': 'Dubai, Vereinigte Arabische Emirate',
  'legal.imprint.contactLabel': 'Kontakt',
  'legal.imprint.contactBody': 'Kontaktinformationen werden ausschließlich nach freiem Ermessen von Scherbius Technology bereitgestellt.',
  'legal.imprint.representationLabel': 'Vertretungsberechtigung',
  'legal.imprint.representationBody': 'Scherbius Technology wird durch seine gesetzlichen Vertreter gemäß dem Recht der Vereinigten Arabischen Emirate vertreten.',
  'legal.imprint.contentLiabilityLabel': 'Haftung für Inhalte',
  'legal.imprint.contentLiabilityBody': 'Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt.\nScherbius Technology übernimmt jedoch keine Gewähr für Richtigkeit, Vollständigkeit oder Aktualität der Inhalte.',
  'legal.imprint.linksLiabilityLabel': 'Haftung für externe Links',
  'legal.imprint.linksLiabilityBody': 'Diese Website enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte kein Einfluss besteht.\nFür diese fremden Inhalte wird keine Haftung übernommen.',
  'legal.imprint.lawLabel': 'Anwendbares Recht',
  'legal.imprint.lawBody': 'Es gilt ausschließlich das Recht der Vereinigten Arabischen Emirate.\nGerichtsstand ist Dubai, VAE.',

  // Overview page (auto-added)
  'overview.greeting': 'Willkommen zurück',
  'overview.greetingSub': 'Hier ist, was auf deinem Verdict-Schreibtisch passiert.',
  'overview.heroCta': 'Neues Urteil',
  'overview.currentPlan': 'Aktuelles Paket',
  'overview.creditsLabel': 'Credits',
  'overview.usedThisCycle': 'In diesem Zyklus genutzt',
  'overview.resetsOn': 'Reset am',
  'overview.unlimitedTitle': 'Unbegrenzt',
  'overview.builderPerk': 'Du hast vollen Builder-Zugang — keine Limits.',
  'overview.runOne': 'Urteil starten',
  'overview.lastVerdicts': 'Deine letzten 5 Urteile',
  'overview.noActivity': 'Noch keine Urteile — starte deine erste Analyse',
  'overview.tipTitle': 'Tipp',
  'overview.tipBody': 'Lass eine Idee durch zwei Sprachen laufen — wenn das Urteil milder wird, sind deine Annahmen lokal, nicht universell.',
  'onboard.skip': "Überspringen",
  'onboard.cta.next': "Weiter",
  'onboard.cta.start': "Jetzt starten",
  'onboard.s1.title': "Willkommen bei IdeaVerdict",
  'onboard.s1.body': "Ein KI-Urteil zu deiner Geschäftsidee — bevor du sie baust.",
  'onboard.s2.title': "Schonungslos ehrliche Urteile",
  'onboard.s2.body': "Kein Hype, keine Schmeichelei. Echte Marktdaten, echte Konkurrenten, echte Risiken.",
  'onboard.s3.title': "Builder-Reports als PDF",
  'onboard.s3.body': "Erstelle 25–75-seitige Reports mit vollständiger Architektur, Finanzen und Go-to-Market-Strategie.",
  'onboard.s4.title': "Bereit, wenn du es bist",
  'onboard.s4.body': "Registriere dich und erhalte dein erstes Urteil in weniger als einer Minute.",
  'builderReport.title': "Builder Report wird erstellt",
  'builderReport.subtitle': "Umfassende Analyse + Developer Briefing — wird als PDF heruntergeladen, sobald es bereit ist.",
  'builderReport.idea': "Deine Idee",
  'builderReport.ideaPlaceholder': "Beschreibe deine Geschäftsidee (oder leer lassen, um die zuletzt besprochene Idee zu verwenden)…",
  'builderReport.cta': "Report erstellen",
  'builderReport.credits': "Credits",
  'builderReport.deductedNow': "Wird bei Erfolg abgezogen",
  'builderReport.dontClose': "Bitte dieses Fenster nicht schließen — die Erstellung kann 30-90 Sekunden dauern.",
  'builderReport.done': "PDF heruntergeladen — siehe deinen Downloads-Ordner.",
  'builderReport.failed': "Erstellung fehlgeschlagen",
  'builderReport.close': "Schließen",
  'builderReport.cancel': "Abbrechen",
  'builderReport.running': "Wird erstellt…",
  'builderReport.retry': "Erneut versuchen",
  'builderReport.unknownError': "Erstellung fehlgeschlagen. Deine Credits sollten erstattet werden.",
  'builderReport.signInRequired': "Du musst angemeldet sein, um einen Report zu erstellen.",
  'builderReport.ideaRequired': "Bitte beschreibe deine Idee, damit die KI etwas zum Analysieren hat.",
  'builderReport.fromChat': "Aus deiner aktuellen Unterhaltung",
  'builderReport.noIdeaDetected': "Wir verwenden die Idee, die wir besprochen haben.",
  'builderReport.contextHint': "Die KI verwendet alles aus diesem Chat — es wird keine neue Idee erfunden.",
  'builderReport.step.core': "Kernanalyse wird erstellt",
  'builderReport.step.market': "Erweiterte Marktanalyse wird hinzugefügt",
  'builderReport.step.tech': "Technische Architektur wird hinzugefügt",
  'builderReport.step.financials': "Finanzmodelle werden hinzugefügt",
  'builderReport.step.compet': "Wettbewerbsanalyse wird hinzugefügt",
  'builderReport.step.gtm': "Go-to-Market-Strategie wird hinzugefügt",
  'builderReport.step.deepdive': "Branchen-Tiefenanalyse wird hinzugefügt",
  'builderReport.step.pdf': "PDF wird kompiliert…",
  'briefing.title': "Developer Briefing wird erstellt",
  'briefing.subtitle': "11-teiliges technisches Briefing — wird als PDF heruntergeladen, sobald es bereit ist.",
  'briefing.ideaPlaceholder': "Beschreibe deine Geschäftsidee (oder leer lassen, um die zuletzt besprochene Idee zu verwenden)…",
  'briefing.cta': "Briefing erstellen",
  'briefing.step.core': "Developer Briefing wird erstellt",
  'briefing.step.pdf': "PDF wird kompiliert…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Mehr Credits + 50-Seiten-Reports",
  'pricing.gold.credits': "12.500 Credits pro Monat",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Höchste Stufe + 75-Seiten-Reports",
  'pricing.platinum.credits': "15.000 Credits pro Monat",
  'trial.creditsLow': "Nur noch {{count}} Credits übrig!",
  'trial.upgradeNow': "Jetzt upgraden",
  'trial.upgradeNowArrow': "Jetzt upgraden →",
  'trial.creditsExhausted': "Credits aufgebraucht",
  'trial.upgradeForUnlimited': "Upgrade für unbegrenzte Nutzung",
  'trial.noCreditsPlaceholder': "Keine Credits mehr verfügbar…",
  'hero.badgeHonest': "Ehrliche, unvoreingenommene KI",
  'hero.badge60sec': "Urteil in 60 Sekunden",
  'hero.badge20Lang': "20+ Sprachen",
  'hero.widget.label': "Idee-Urteil",
  'hero.widget.passed': "BESTANDEN",
  'hero.widget.demoIdea': "KI-Tutor für Medizinstudenten",
  'hero.widget.market': "Markt",
  'hero.widget.demand': "Nachfrage",
  'hero.widget.competition': "Konkurrenz",
  'hero.widget.verdictReady': "Urteil bereit · 47 Sek.",
  'hero.widget.riskFlagged': "Risiko markiert",
  'hero.widget.crowdedMarket': "Übersättigter Markt · 4 Etablierte",
  'hero.widget.suggestedPivot': "Vorgeschlagener Pivot",
  'hero.widget.nicheBySpecialty': "Nische nach Fachgebiet",
  'hero.widget.feasibilityGain': "+38% Machbarkeit",
  'hero.widget.analysisDone': "Analyse abgeschlossen",
  'hero.widget.metrics56': "5 von 6 Metriken",
  'hero.stats.verdictSpeed': "Urteilsgeschwindigkeit",
  'cta.badge': "Urteil in 60 Sekunden",
  'cta.subtitleEnd': "ohne zu raten.",
  'cta.signinPrompt': "Bereits ein Konto? Anmelden",
  'cta.trustTrial': "7-Tage kostenlose Testphase",
  'cta.trustNoCard': "Keine Karte erforderlich",
  'cta.trustCancel': "Jederzeit kündbar",
  'footer.themeLabel': "Theme:",
  'footer.lightMode': "Heller Modus",
  'footer.darkMode': "Dunkler Modus",
  'footer.sectionProduct': "Produkt",
  'footer.sectionLegal': "Rechtliches",
  'nav.switchLight': "Zum hellen Modus",
  'nav.switchDark': "Zum dunklen Modus",
  'features.badge': "Warum IdeaVerdict",
  'features.mainFeatureLabel': "Headline",
  'chatError.planRestriction': "Diese Funktion erfordert einen höheren Tarif.",
  'chatError.creditDeduction': "Zahlung fehlgeschlagen. Bitte erneut versuchen.",
  'chatError.aiService': "KI-Dienst vorübergehend nicht verfügbar. Deine Credits wurden nicht belastet. Bitte erneut versuchen.",
  'chatError.parseError': "Unerwartetes Antwortformat erhalten. Bitte erneut versuchen.",
  'chatError.sessionExpired': "Deine Sitzung ist abgelaufen. Bitte erneut anmelden.",
  'chatError.timeout': "Die Anfrage hat zu lange gedauert. Bitte erneut versuchen.",
  'chatError.generic': "Antwort konnte nicht abgerufen werden. Bitte erneut versuchen.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "de" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "Only {credits} credits left!",
  'trial.outOfCredits': "Out of credits",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "Crowded market · 4 incumbents",
  'hero.widget.nicheBySpec': "Niche by specialty",
  'hero.widget.feasibilityUp': "+38% feasibility",
  'hero.widget.fiveOfSix': "5 of 6 metrics",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "25-Seiten Builder Report",
  'pricing.gold.report': "50-Seiten Builder Report",
  'pricing.platinum.report': "75-Seiten Builder Report",
  'auth.bestValue': "Bester Wert",
  'auth.elite': "Elite",
  'builderReport.friendlyError': "Wir konnten deinen Report diesmal nicht fertigstellen. Deine Credits wurden nicht belastet — bitte versuche es in einem Moment erneut.",
  'builderReport.persistHint': "Wenn das Problem weiter auftritt, melde dich bei support@ideaverdict.ai.",
};
